var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { compareIgnoreCase, containsIgnoreCase, toLowerCaseArray, removeEmptyValues, toLowerCaseDictionary } from "@ane/core/lib/utils/CommonStringUtils";
import { CommonUtilsInstance } from "@ane/core/lib/utils/CommonUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import * as _ from "lodash";
import "./models/index.js";
import { getDefaultProgressionSelectionTemplates, getDefaultProgressionSettingsMetadata } from "./defaultData/ProgressionSelectionInitialData.js";
import { OperatorConstants, OperatorCategory, ValueType, CustomOperatorConstants, isRangeOperator } from "./models/TrafficFilterModel.js";
import { FlightType, TreatmentVariableType, ProgressionCategory, ProgressionType, TrafficDistributionType, ProgressionUserInterfaceType, StageTrafficSource, ExperimentStates, ExperimentStepStates, ProgressionSettingsType, ExperimentStepType, IsolationGroupCategoryOption, OverrideType } from "./models/FeatureDataModel.js";
import { getDefaultOperationState, getDefaultFlight, getDefaultTreatmentVariable, getDefaultCompletedOperationCheck } from "./defaultData/FeatureInitialData.js";
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
import { getAggregatedProgressionState, getAggregatedState, ProgressionStageStateUtilsInstance, isProgressionStateNotRunning, isProgressionNotStarted, isProgressionRunningOrStopping, isProgressionStageRunningAt100Percent } from "./utils/ExperimentStateUtils.js";
import { ConfigProviderMigrationState } from "./models/expapi/FeatureApiModel.js";
import "./constants/constants.js";
import { gatingUtils } from "./utils/GatingUtils.js";
import { inputInvalidIntegerMessage, inputInvalidStringValueMessage, inputInvalidLongStringValueMessage, inputInvalidVersionValueMessage, inputInvalidRangeMultipleValueMessage, inputInvalidRangeMissingValueMessage, inputInvalidBetweenRangeValueMessage, inputInvalidOrRangeValueMessage } from "./constants/AudienceFilterValidation.constants.js";
import OperationCheckUtils from "./utils/OperationCheckUtils.js";
import { studioProgression, PermissionMessages } from "./constants/FeatureDataConstants.js";
import { OperationCheckTypes } from "./models/OperationCheckModels.js";
const hasTreatmentVariables = (flights) => {
  return _.some(flights || [], (f) => f.treatmentVariables.length > 0);
};
const getRandomIntInclusive = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
const generateNewFlightName = (tvNamespace, name) => {
  return tvNamespace.substring(0, 2) + name.substring(0, 3) + getRandomIntInclusive(100, 999);
};
const createControlFlight = (treatmentFlight) => {
  return {
    name: `${treatmentFlight.name}${getControlFlightSuffix()}`,
    type: FlightType.CustomControl,
    isControlEnabled: false,
    treatmentVariables: treatmentFlight.treatmentVariables.filter((tv) => tv.type === TreatmentVariableType.Boolean).map((tv) => {
      return {
        name: tv.name,
        type: tv.type,
        value: tv.value.toLowerCase() === "true" ? "false" : "true",
        namespace: tv.namespace
      };
    }),
    isCreated: treatmentFlight.isCreated,
    isolationGroups: treatmentFlight.isolationGroups,
    isValidating: false,
    composition: [],
    isSaved: treatmentFlight.isSaved
  };
};
const getExpandedFlightList = (flightList) => {
  let flights = _.cloneDeep(flightList.flights);
  return flights;
};
const EDITABLE_FLIGHTS = {
  [FlightType.Treatment]: true,
  [FlightType.CustomControl]: true,
  [FlightType.Interleaving]: true
};
const getEditableFlights = (flightDict) => {
  return _.filter(Object.values(flightDict), (flight) => !!EDITABLE_FLIGHTS[flight.flightType]);
};
const generateRandomFlightName = (strLength) => {
  return Math.random().toString(20).substr(2, strLength);
};
const getFormattedTreatmentVariables = (flight, prefix = "", separator = "; ") => {
  if (!!flight.TreatmentVariables && flight.TreatmentVariables.length > 0) {
    return `${prefix}${flight.TreatmentVariables.map((tv) => `${tv.Key}: ${tv.Value}`).join(separator)}`;
  }
  return "";
};
const validateFlightName = (value, maxLength) => {
  if (!validateFlightNameCharacters(value)) {
    return "Name can only include alphanumeric, and/or hyphen/underscore (-/_) (except first/last character)";
  }
  if (value.length > maxLength) {
    return `Name length must be ${maxLength} characters or less.`;
  }
  return null;
};
const validateFlightNameCharacters = (value) => {
  var result = new RegExp("^([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9]|[a-zA-Z0-9]*)$");
  return result.test(value);
};
class FeatureUtilsV2 {
  parseProgressions(progressionDtos, mdsFilters, rootFlightList, progressionTemplatesBySnapshot, mdsProgressionTemplates, onlyArchivedProgressions) {
    progressionDtos = this.normalizeProgressionTrafficFilter(progressionDtos, mdsFilters);
    return progressionDtos.filter((p) => p.FlightNames && p.FlightNames.length > 0).map(
      (p) => this.parseProgression(
        p,
        mdsFilters,
        rootFlightList,
        // @ts-ignore
        this.getMdsProgressionTemplates(progressionTemplatesBySnapshot, p.MdsSnapshot, mdsProgressionTemplates),
        onlyArchivedProgressions
      )
    );
  }
  getMdsProgressionTemplates(progressionTemplatesBySnapshot, mdsSnapshot, defaultVal) {
    if (!mdsSnapshot || !progressionTemplatesBySnapshot) {
      return defaultVal;
    }
    return !!progressionTemplatesBySnapshot[mdsSnapshot] ? progressionTemplatesBySnapshot[mdsSnapshot].ProgressionTemplates : defaultVal;
  }
  convertTreatmentVariable(treatmentVariables) {
    let convertedTreatmentVariables = [];
    if (!!treatmentVariables) {
      treatmentVariables.forEach((t) => {
        let currentTreatmentVariable = {
          // @ts-ignore
          name: t.Key,
          // @ts-ignore
          type: TreatmentVariableType[t.Type],
          // @ts-ignore
          value: t.Value
        };
        convertedTreatmentVariables.push(currentTreatmentVariable);
      });
    }
    return convertedTreatmentVariables;
  }
  parseProgression(progression, mdsFilters, rootFlightList, mdsProgressionTemplates, onlyArchivedProgressions) {
    let flights = progression.FlightNames;
    let flightsInProgressionsStages = [];
    progression.Studies.forEach((study) => {
      let flightsFromStudies = Object.values(study.Flights);
      flightsFromStudies.forEach((f) => {
        let flightConverted = {
          name: f.Name,
          // @ts-ignore
          type: FlightType[f.FlightType],
          // @ts-ignore
          treatmentVariables: this.convertTreatmentVariable(f.TreatmentVariables),
          isControlEnabled: true,
          isCreated: true,
          // @ts-ignore
          isolationGroups: f.IsolationGroups,
          isValidating: false
        };
        flightsInProgressionsStages.push(flightConverted);
      });
      flights = flights.concat(Object.keys(study.Flights));
      if (compareIgnoreCase(progression.ProgressionType, "SingleTreatmentProgression")) {
        const treatmentFlights = Object.values(study.Flights).filter((flight) => flight.FlightType === FlightType.Treatment);
        treatmentFlights.forEach((fl) => {
          flights = flights.concat(`${fl.Name}${getControlFlightSuffix()}`);
        });
      }
    });
    const finalFlightsList = _.uniq(flights);
    const uniqueFlightsInProgressionsStages = _.uniqBy(flightsInProgressionsStages, (f) => {
      var _a;
      return (_a = f == null ? void 0 : f.name) == null ? void 0 : _a.toLowerCase();
    });
    let progressionFlights = this.parseTreatmentAndControlFlight(
      rootFlightList,
      finalFlightsList,
      progression.FlightNames,
      uniqueFlightsInProgressionsStages
    );
    const progressionStages = _.map(
      progression.Studies ? progression.Studies : [],
      (s) => {
        var _a;
        return this.parseProgressionStage(
          s,
          mdsFilters,
          // @ts-ignore
          !!mdsProgressionTemplates ? mdsProgressionTemplates[progression.TrialTemplateId] : null,
          // @ts-ignore
          (_a = progression.ConfigProviderInfo) == null ? void 0 : _a.LatestConfigProviderMigrationState
        );
      }
    ).sort((t1, t2) => t1.sequenceIndex - t2.sequenceIndex);
    const allGroupedProgressionStages = groupRestartedProgressionStages(progressionStages);
    const filteredGroupedStages = allGroupedProgressionStages.filter((stg) => {
      const restartedProgStages = allGroupedProgressionStages.filter((gs) => gs.restartedFromId === stg.id);
      const hiddenRestartedProgStages = restartedProgStages.filter((gs) => gs.isHidden);
      const showStage = hiddenRestartedProgStages.length && hiddenRestartedProgStages.length === restartedProgStages.length;
      return progression.IsArchived ? stg.isHidden && (!restartedProgStages.length || showStage) : !stg.isHidden && (!restartedProgStages.length || showStage);
    });
    const progressionCategory = mdsProgressionTemplates && // @ts-ignore
    mdsProgressionTemplates[progression.TrialTemplateId] && // @ts-ignore
    compareIgnoreCase(mdsProgressionTemplates[progression.TrialTemplateId].Category, "freeform") ? ProgressionCategory.FreeForm : ProgressionCategory.Restricted;
    return {
      // @ts-ignore
      id: progression.Id,
      // @ts-ignore
      name: progression.Name,
      // @ts-ignore
      templateName: progression.TrialTemplateId,
      flights: progressionFlights,
      state: getAggregatedProgressionState(allGroupedProgressionStages),
      filteredProgressionStages: filteredGroupedStages,
      allProgressionStages: allGroupedProgressionStages,
      progressionType: CommonUtilsInstance.getEnumIgnoreCase(
        ProgressionType,
        // @ts-ignore
        progression.ProgressionType,
        ProgressionType.SingleTreatmentProgression
      ),
      trafficDistributionType: CommonUtilsInstance.getEnumIgnoreCase(
        TrafficDistributionType,
        // @ts-ignore
        progression.TrafficDistributionType,
        TrafficDistributionType.SingleTreatmentMirrorControl
      ),
      progressionUserInterfaceType: CommonUtilsInstance.getEnumIgnoreCase(
        ProgressionUserInterfaceType,
        // @ts-ignore
        progression.ProgressionUserInterfaceType,
        ProgressionUserInterfaceType.HorizontalCards
      ),
      // @ts-ignore
      progressionFilters: parseTrafficFilters(progression.TrafficFilters, mdsFilters),
      mdsSnapshot: progression.MdsSnapshot,
      clonedFromId: progression.ClonedFromId,
      // @ts-ignore
      created: progression.Created,
      category: progressionCategory,
      trafficAllocation: progression.TrafficAllocationPercentage,
      resaltOnStart: progression.ResaltOnStart,
      isArchived: progression.IsArchived,
      // @ts-ignore
      configProviderInfo: this.getProgressionConfigProviderInfo(progression.ConfigProviderInfo)
    };
  }
  normalizeProgressionTrafficFilter(progressions, mdsTrafficFilters) {
    const progressionDtos = _.cloneDeep(progressions);
    _.forEach(progressionDtos, (singleProgression) => {
      if (!!singleProgression.TrafficFilters) {
        CommonUtilsInstance.correctCasingForKeys(singleProgression.TrafficFilters, mdsTrafficFilters);
      }
      if (!!singleProgression.Studies) {
        _.forEach(singleProgression.Studies, (progressionTarget) => {
          if (!!progressionTarget.TrafficFilterSets) {
            _.forOwn(progressionTarget.TrafficFilterSets, (trafficFilters) => {
              CommonUtilsInstance.correctCasingForKeys(trafficFilters, mdsTrafficFilters);
            });
          }
        });
      }
    });
    return progressionDtos;
  }
  convertFlightType(backendFlightType) {
    if (compareIgnoreCase(backendFlightType, "treatment") || compareIgnoreCase(backendFlightType, "reservetreatment")) {
      return FlightType.Treatment;
    } else if (compareIgnoreCase(backendFlightType, "standardcontrol")) {
      return FlightType.StandardControl;
    } else {
      return FlightType.CustomControl;
    }
  }
  parseProgressionStage(progressionStageConfigDto, mdsFilters, mdsProgressionTemplate, configProviderMigrationState) {
    if (!progressionStageConfigDto.Stages) {
      progressionStageConfigDto.Stages = [];
    }
    const flightTypeMap = {};
    _.each(progressionStageConfigDto.Flights, (f) => {
      flightTypeMap[f.Name] = this.convertFlightType(f.FlightType);
    });
    let aggregatedState = getAggregatedState(
      // @ts-ignore
      !!configProviderMigrationState && configProviderMigrationState !== ConfigProviderMigrationState.new && configProviderMigrationState !== ConfigProviderMigrationState.migrationFailed ? [configProviderMigrationState.toString()] : progressionStageConfigDto.Stages.map((s) => s.State)
    );
    let trafficFilters = parseTrafficFilters(this.getTrafficFilterForProgressionStage(progressionStageConfigDto), mdsFilters);
    if (EnvironmentService.isUnifiedView) {
      trafficFilters = __spreadValues(__spreadValues({}, trafficFilters), MasterDataUtilInstance.getTrafficFiltersFromMDSFilters(mdsFilters, true, true));
      if (!!progressionStageConfigDto.TrafficFilterSets) {
        _.forOwn(progressionStageConfigDto.TrafficFilterSets, (set, key) => {
          trafficFilters = __spreadValues(__spreadValues({}, trafficFilters), parseTrafficFilters(set, mdsFilters, true));
        });
      }
    }
    const mdsSequenceIndex = progressionStageConfigDto.ExperimentTrialConfiguration ? progressionStageConfigDto.ExperimentTrialConfiguration.MdsSequenceIndex : -1;
    const progressionStage = {
      id: progressionStageConfigDto.Id,
      // @ts-ignore
      sequenceIndex: progressionStageConfigDto.ExperimentTrialConfiguration ? progressionStageConfigDto.ExperimentTrialConfiguration.SequenceIndex : -1,
      // @ts-ignore
      mdsSequenceIndex,
      // @ts-ignore
      friendlyName: progressionStageConfigDto.Name,
      unlockWithPrevious: !!mdsProgressionTemplate && !!mdsProgressionTemplate.DefaultUnlockWithPrevious,
      state: aggregatedState,
      isTeamStage: progressionStageConfigDto.IsRolloutOverride,
      initialTrafficFilters: _.cloneDeep(trafficFilters),
      // @ts-ignore
      stages: progressionStageConfigDto.Stages.map((s) => {
        var _a;
        let flightTrafficMap = this.getStageTraffic(s);
        let flightAllocationIdsMap = this.getFlightAllocationIdsMap(s);
        return {
          startDate: !!s.StartTime ? new Date(s.StartTime) : null,
          endDate: !!s.StopTime ? new Date(s.StopTime) : null,
          scorecardLink: null,
          flightTrafficMap,
          flightAllocationIdsMap,
          state: s.State,
          // @ts-ignore
          stepIds: (_a = s.ParallelSteps) == null ? void 0 : _a.map((step) => step.Id),
          // @ts-ignore
          stepTypes: s.ParallelSteps.map((step) => step.Type),
          scorecards: null,
          gatingEntityId: s.GatingEntityId,
          flightTypeMap,
          trafficSource: !!s.TrafficSource && s.TrafficSource.toLowerCase() === "userspecified" ? StageTrafficSource.userSpecified : StageTrafficSource.templateDefined
        };
      }),
      operationCheck: {
        status: AsyncRequestStatus.Pending
      },
      clonedFromId: progressionStageConfigDto.ClonedFromId,
      operationState: getDefaultOperationState(),
      restartedFromId: progressionStageConfigDto.RestartedFromId,
      isHidden: progressionStageConfigDto.IsHidden,
      journals: {
        status: AsyncRequestStatus.Completed,
        data: {
          jounalEntries: []
        }
      },
      isolationGroups: this.parseProgressionStageIsolationGroups(progressionStageConfigDto),
      userRequestedResalt: progressionStageConfigDto.userRequestedResalt
    };
    if (!!mdsProgressionTemplate && mdsSequenceIndex >= 0 && mdsSequenceIndex < mdsProgressionTemplate.Studies.length) {
      let progressionStageTemplate = mdsProgressionTemplate.Studies[mdsSequenceIndex];
      if (_.isBoolean(progressionStageTemplate.UnlockWithPrevious)) {
        progressionStage.unlockWithPrevious = progressionStageTemplate.UnlockWithPrevious;
      }
      this.addTemplateTrafficFilterDataInProgressionStage(
        progressionStage,
        mdsProgressionTemplate.TrialTrafficFilters,
        progressionStageTemplate.StudyTrafficFilters,
        mdsFilters
      );
    }
    return progressionStage;
  }
  parseProgressionStageIsolationGroups(progressionStageConfigDto) {
    if (progressionStageConfigDto && progressionStageConfigDto.Flights && Object.keys(progressionStageConfigDto.Flights).length > 0) {
      return progressionStageConfigDto.Flights[Object.keys(progressionStageConfigDto.Flights)[0]].IsolationGroups;
    }
    return [];
  }
  parseTreatmentAndControlFlight(rootFlightList, flightNames, flightsInProgression, flightsInProgressionsStages) {
    const progressionFlightsNamesBackendLowerCase = flightNames.map((f) => f.toLowerCase());
    const expandedFlights = getExpandedFlightList(rootFlightList);
    const progressionFlights = expandedFlights.filter((f) => containsIgnoreCase(progressionFlightsNamesBackendLowerCase, f.name));
    if (progressionFlights.length === 0) {
      let flightsFromProgressionStage = flightsInProgressionsStages.filter(
        (f) => containsIgnoreCase(progressionFlightsNamesBackendLowerCase, f.name)
      );
      flightsFromProgressionStage.forEach((flight) => {
        flight.isInitialProgressionFlight = true;
      });
      return flightsFromProgressionStage;
    }
    progressionFlights.forEach((flight) => {
      flight.isInitialProgressionFlight = containsIgnoreCase(flightsInProgression, flight.name);
    });
    return progressionFlights;
  }
  getTrafficFilterForProgressionStage(progressionStageConfigDto) {
    if (progressionStageConfigDto.Stages.length === 0 || progressionStageConfigDto.Stages[0].ParallelSteps.length === 0) {
      return {};
    }
    let stagesLength = progressionStageConfigDto.Stages.length;
    let lastStageTrafficFilterName = progressionStageConfigDto.Stages[stagesLength - 1].ParallelSteps[0].TrafficFilterSetId;
    if (!lastStageTrafficFilterName) {
      return {};
    }
    return progressionStageConfigDto.TrafficFilterSets[lastStageTrafficFilterName];
  }
  getStageTraffic(stage) {
    return stage.ParallelSteps && stage.ParallelSteps.length > 0 ? stage.ParallelSteps[0].FlightTrafficMap : {};
  }
  getFlightAllocationIdsMap(stage) {
    if (!stage || !stage.ParallelSteps || stage.ParallelSteps.length === 0 || !stage.ParallelSteps[0].FlightAllocationIdsMap) {
      return {};
    }
    return stage.ParallelSteps[0].FlightAllocationIdsMap;
  }
  addTemplateTrafficFilterDataInProgressionStage(progressionStage, progressionTrafficFiltersInTemplate, progressionStageTrafficFiltersInTemplate, mdsFilters) {
    const mergeTrafficFilterInTemplate = CommonUtilsInstance.LeftMergeDictionary(
      progressionStageTrafficFiltersInTemplate,
      progressionTrafficFiltersInTemplate
    );
    this.supplementProgressionStageWithTemplateData(
      mergeTrafficFilterInTemplate,
      mdsFilters,
      progressionStage.initialTrafficFilters
    );
  }
  supplementProgressionStageWithTemplateData(trafficFiltersInTemplate, mdsFilters, initialTrafficFilterDictionary) {
    const templateKeys = Object.keys(trafficFiltersInTemplate);
    const templateTrafficFilters = this.parseTrafficFiltersFromTemplate(trafficFiltersInTemplate, mdsFilters);
    _.each(templateKeys, (templateKey) => {
      if (!!trafficFiltersInTemplate[templateKey]) {
        let trafficFilterKey = CommonUtilsInstance.getMatchingKeyIgnoreCase(
          initialTrafficFilterDictionary.trafficFilters,
          templateKey
        );
        if (!trafficFilterKey) {
          trafficFilterKey = templateKey;
          let defaultVal = __spreadProps(__spreadValues({}, _.cloneDeep(templateTrafficFilters.trafficFilters[templateKey])), {
            currentValue: {
              clause: []
            }
          });
          initialTrafficFilterDictionary.trafficFilters[trafficFilterKey] = _.cloneDeep(defaultVal);
        }
        initialTrafficFilterDictionary.trafficFilters[trafficFilterKey].isEditable = trafficFiltersInTemplate[templateKey].IsEditable || false;
        initialTrafficFilterDictionary.trafficFilters[trafficFilterKey].isRequired = trafficFiltersInTemplate[templateKey].IsRequired || false;
        initialTrafficFilterDictionary.trafficFilters[trafficFilterKey].allowNoFilter = trafficFiltersInTemplate[templateKey].AllowNoFilter || false;
      }
    });
  }
  parseTrafficFiltersFromTemplate(trafficFilters, mdsFilters) {
    let trafficFilterDictionary = {};
    const keys = Object.keys(trafficFilters);
    _.forEach(keys, (key) => {
      trafficFilterDictionary[key] = trafficFilters[key].Values;
    });
    const parsed = parseTrafficFilters(trafficFilterDictionary, mdsFilters);
    _.forEach(keys, (key) => {
      parsed.trafficFilters[key].isEditable = trafficFilters[key].IsEditable || false;
      parsed.trafficFilters[key].isRequired = trafficFilters[key].IsRequired || false;
      parsed.trafficFilters[key].allowNoFilter = trafficFilters[key].AllowNoFilter || false;
    });
    return parsed;
  }
  isAutoGeneratedIsolationGroup(isolationGroups, autoGeneratedIsolationGroup) {
    return !isolationGroups || isolationGroups.length === 0 || // Note: technically we should never have autog-generated IG mixing with existing IG
    !!autoGeneratedIsolationGroup && isolationGroups.length === 1 && compareIgnoreCase(isolationGroups[0], autoGeneratedIsolationGroup);
  }
  getFlightIsolationGroups(isAutoGeneratedIG, autoGeneratedIsolationGroup, selectedIsolationGroups) {
    if (isAutoGeneratedIG) {
      return autoGeneratedIsolationGroup ? [autoGeneratedIsolationGroup] : [];
    } else {
      return selectedIsolationGroups;
    }
  }
  getFlightComposition(enableComboFlight, composition) {
    if (enableComboFlight) {
      return _.map(composition, (c) => {
        return {
          FlightName: c
        };
      });
    }
    return null;
  }
  getSelectableChildFlights(allFlights) {
    return _.uniq(
      _.map(
        _.filter(allFlights, (f) => !!f.name && !f.isCombo),
        (f) => f.name
      )
    );
  }
  getSelectedChildFlights(flights) {
    return _.uniq(_.flatten(_.map(flights, (f) => f.composition || [])));
  }
  getProgressionConfigProviderInfo(configProviderInfo) {
    const latestConfigProviderMigrationState = configProviderInfo == null ? void 0 : configProviderInfo.LatestConfigProviderMigrationState;
    let migrationStatus = AsyncRequestStatus.NotStarted;
    switch (latestConfigProviderMigrationState) {
      case ConfigProviderMigrationState.migrating:
        migrationStatus = AsyncRequestStatus.Pending;
        break;
      case ConfigProviderMigrationState.migrationSucceeded:
        migrationStatus = AsyncRequestStatus.Completed;
        break;
      case ConfigProviderMigrationState.migrationFailed:
        migrationStatus = AsyncRequestStatus.Failed;
        break;
    }
    return {
      status: migrationStatus,
      data: configProviderInfo
    };
  }
  addNewFlight(flightType, isCombo, flights, isolationGroups, treatmentVariableEnabled, isControlEnabledDefault, name, treatmentVariables) {
    const newFlight = getDefaultFlight(isolationGroups, treatmentVariableEnabled, isControlEnabledDefault);
    newFlight.type = flightType;
    newFlight.isCombo = isCombo;
    if (name) {
      newFlight.name = name;
    }
    if (treatmentVariables) {
      newFlight.treatmentVariables = treatmentVariables;
    }
    return [...flights, newFlight];
  }
  deleteFlight(flights, index) {
    const newFlights = _.cloneDeep(flights);
    newFlights.splice(index, 1);
    return newFlights;
  }
  addEmptyTreatmentVariable(flight, namespace) {
    const newFlight = _.cloneDeep(flight);
    const newTreatmentVariable = getDefaultTreatmentVariable(namespace);
    newFlight.treatmentVariables.push(newTreatmentVariable);
    return newFlight;
  }
  deleteTreatmentVariable(index, treatmentVariables) {
    const newTreatmentVariables = _.cloneDeep(treatmentVariables);
    newTreatmentVariables.splice(index, 1);
    return newTreatmentVariables;
  }
}
const featureUtilsV2Instance = new FeatureUtilsV2();
var ProgressionStageEditAvailability = /* @__PURE__ */ ((ProgressionStageEditAvailability2) => {
  ProgressionStageEditAvailability2[ProgressionStageEditAvailability2["enable"] = 0] = "enable";
  ProgressionStageEditAvailability2[ProgressionStageEditAvailability2["blockedByNewIteration"] = 1] = "blockedByNewIteration";
  ProgressionStageEditAvailability2[ProgressionStageEditAvailability2["blockedByApprovalGate"] = 2] = "blockedByApprovalGate";
  ProgressionStageEditAvailability2[ProgressionStageEditAvailability2["blockedByProgressionMigration"] = 3] = "blockedByProgressionMigration";
  return ProgressionStageEditAvailability2;
})(ProgressionStageEditAvailability || {});
var IterateProgressionDisableReasons = /* @__PURE__ */ ((IterateProgressionDisableReasons2) => {
  IterateProgressionDisableReasons2["disabledByProgressionMigration"] = "The progression has been migrated to ECS where any further changes to the stage must take place.";
  IterateProgressionDisableReasons2["disabledByParentIsRunning"] = "The parent progression is still Running.";
  IterateProgressionDisableReasons2["disabledByAlreadyIterated"] = "Progression is already Iterated.";
  IterateProgressionDisableReasons2["disabledByStudioProgression"] = "Migrated Studio progressions can not be iterated.";
  return IterateProgressionDisableReasons2;
})(IterateProgressionDisableReasons || {});
var RelativePosition = /* @__PURE__ */ ((RelativePosition2) => {
  RelativePosition2[RelativePosition2["before"] = 0] = "before";
  RelativePosition2[RelativePosition2["after"] = 1] = "after";
  return RelativePosition2;
})(RelativePosition || {});
class ProgressionUtils {
  getEnabledProgressionStages(progression, clonedFromProgression = null) {
    const progressionStages = progression.filteredProgressionStages;
    let enabledStages = {};
    progressionStages.forEach((progressionStage, index) => {
      var _a, _b;
      const prevProgressionStage = index > 0 ? progressionStages[index - 1] : null;
      const stages = (_a = prevProgressionStage == null ? void 0 : prevProgressionStage.stages) != null ? _a : [];
      const lastStageInPrevProgressionStage = stages == null ? void 0 : stages[stages.length - 1];
      let lessThanFrontierStageIndex = index <= progression.state.FrontierStageIndex;
      let prevProgStageInLastStep = !!prevProgressionStage && ((_b = lastStageInPrevProgressionStage == null ? void 0 : lastStageInPrevProgressionStage.state) == null ? void 0 : _b.toLowerCase()) !== ExperimentStates.NEW;
      let unlockWithPrevStage = prevProgressionStage && !!progressionStage.unlockWithPrevious && enabledStages[prevProgressionStage.id];
      let stageAlreadyStarted = (EnvironmentService.enableNoStepsInStageFix() ? progressionStage.stages[progressionStage.state.FrontierStageIndex] : true) && progressionStage.stages[progressionStage.state.FrontierStageIndex].state.toLowerCase() !== ExperimentStates.NEW;
      enabledStages[progressionStage.id] = index === 0 || lessThanFrontierStageIndex || prevProgStageInLastStep || unlockWithPrevStage || stageAlreadyStarted;
    });
    if (!!clonedFromProgression) {
      const parentEnabledStages = this.getEnabledProgressionStages(clonedFromProgression);
      let i;
      for (i = 0; i < progression.filteredProgressionStages.length; ++i) {
        const stage = progression.filteredProgressionStages[i];
        if (!!parentEnabledStages[stage.clonedFromId]) {
          enabledStages[stage.id] = true;
        }
      }
    }
    return enabledStages;
  }
  getStartDate(progressionStage) {
    let startDate = null;
    let stoppedStages = progressionStage.stages.filter((stage) => !!stage.startDate).sort((s1, s2) => {
      let t1 = !!s1.startDate ? s1.startDate.getTime() : 0;
      let t2 = !!s2.startDate ? s2.startDate.getTime() : 0;
      return t1 - t2;
    });
    if (stoppedStages.length > 0) {
      startDate = stoppedStages[0].startDate;
    }
    return startDate;
  }
  getEndDate(progressionStage) {
    let endDate = null;
    let stoppedStages = progressionStage.stages.filter((stage) => !!stage.endDate).sort((s1, s2) => {
      let t1 = !!s1.endDate ? s1.endDate.getTime() : 0;
      let t2 = !!s2.endDate ? s2.endDate.getTime() : 0;
      return t2 - t1;
    });
    if (stoppedStages.length > 0) {
      endDate = stoppedStages[0].endDate;
    }
    return endDate;
  }
  getStartDateFormatted(progressionStage) {
    const startDate = this.getStartDate(progressionStage);
    const startDateStr = !!startDate ? startDate.getMonth() + 1 + "/" + startDate.getDate() + "/" + startDate.getFullYear() : "N/A";
    return startDateStr;
  }
  getEndDateFormatted(progressionStage) {
    const endDate = this.getEndDate(progressionStage);
    const endDateStr = !!endDate ? endDate.getMonth() + 1 + "/" + endDate.getDate() + "/" + endDate.getFullYear() : "N/A";
    return endDateStr;
  }
  getExperimentStageConfiguration(trafficDistributionType, treatmentFlight, controlFlight, allFlightNames, trafficSteps, showIteration = false) {
    return trafficDistributionType === TrafficDistributionType.EvenDistributionAllFlights ? this.getExperimentStageConfigurationForEvenDistrubution(allFlightNames, trafficSteps, showIteration) : this.getExperimentStageConfigurationForStandard(treatmentFlight, controlFlight, trafficSteps, showIteration);
  }
  // If flightTrafficMap exists in current stage, we are using per flight traffic input feature
  // since the different flight have different traffic percentage. Otherwise, we need to compute
  // flightTrafficMap in the runtime.
  getExperimentStageConfigurationForStandard(treatmentFlight, controlFlight, trafficSteps, showIteration = false) {
    const sortedTrafficSteps = showIteration ? this.sortAllExperimentStages(trafficSteps, treatmentFlight) : this.sortExperimentStages(trafficSteps, treatmentFlight);
    return sortedTrafficSteps.filter((stage) => !this.isInvalidTraffic(stage.trafficPercentage)).map((pendingStage) => {
      return {
        ParallelSteps: [
          {
            Type: this.getStageStepType(pendingStage),
            FlightTrafficMap: pendingStage.flightTrafficMap != null ? this.convertFlightMap(pendingStage) : this.getTrafficMap(treatmentFlight, controlFlight, pendingStage.trafficPercentage)
          }
        ]
      };
    });
  }
  getExperimentStageConfigurationForEvenDistrubution(flightNames, trafficSteps, showIteration = false) {
    const sortedTrafficSteps = showIteration ? this.sortAllExperimentStages(trafficSteps) : this.sortExperimentStages(trafficSteps);
    return sortedTrafficSteps.filter((stage) => !this.isInvalidTraffic(stage.trafficPercentage)).map((pendingStage) => {
      return {
        ParallelSteps: [
          {
            Type: this.getStageStepType(pendingStage),
            FlightTrafficMap: pendingStage.flightTrafficMap != null ? this.convertFlightMap(pendingStage) : this.getTrafficMapForEqualDivide(flightNames, pendingStage.trafficPercentage)
          }
        ]
      };
    });
  }
  convertFlightMap(stage) {
    let trafficMap = {};
    let originalTrafficMap = stage.flightTrafficMap;
    for (var key in originalTrafficMap) {
      trafficMap[key] = +originalTrafficMap[key];
    }
    return trafficMap;
  }
  isFreeFormAllowed(progressionCategory, freeFormFlag) {
    return progressionCategory === ProgressionCategory.FreeForm && !!freeFormFlag;
  }
  isInvalidTraffic(traffic) {
    return traffic < 0.1 || traffic > 100 || !traffic;
  }
  isControlFlightSupported(traffic) {
    return !this.isInvalidTraffic(traffic) && traffic <= 50;
  }
  isFlightGettingUsedInProgression(progressionCloneGroups, flightName) {
    return Object.keys(progressionCloneGroups).some(
      (key) => !!progressionCloneGroups[key].find(
        (p) => p.flights && !p.isArchived && containsIgnoreCase(
          p.flights.map((f) => f.name),
          flightName
        )
      )
    );
  }
  isFlightGettingUsedInOverride(overrideState, flightName) {
    var _a;
    let used = false;
    ((_a = overrideState == null ? void 0 : overrideState.overrideSets) != null ? _a : []).map((state) => {
      var _a2, _b, _c, _d, _e, _f;
      let frontierIndex = -1;
      ((_b = (_a2 = state == null ? void 0 : state.overrideSet) == null ? void 0 : _a2.stages) != null ? _b : []).map((stage, stageIndex) => {
        if ((stage == null ? void 0 : stage.state.toLowerCase()) != ExperimentStates.NEW && (stage == null ? void 0 : stage.state.toLowerCase()) != ExperimentStepStates.COMPLETED) {
          frontierIndex = stageIndex;
        }
      });
      if (frontierIndex == -1) {
        frontierIndex = ((_d = (_c = state == null ? void 0 : state.overrideSet) == null ? void 0 : _c.stages) != null ? _d : []).length - 1;
      }
      ((_f = (_e = state == null ? void 0 : state.overrideSet) == null ? void 0 : _e.stages) != null ? _f : []).map((stage, stageIndex) => {
        var _a3;
        if (stageIndex >= frontierIndex) {
          ((_a3 = stage == null ? void 0 : stage.overrides) != null ? _a3 : []).map((override) => {
            if (override.flightName === flightName) {
              used = true;
            }
          });
        }
      });
    });
    return used;
  }
  getFlightInProgression(progression, flightType, initialProgressionFlights = false) {
    let flights = this.getFlightsInProgression(progression, flightType, initialProgressionFlights);
    return flights.length > 0 ? flights[0] : null;
  }
  getFlightInProgressionStage(progression, progressionStage, flightType) {
    let flights = this.getFlightsInProgression(progression, flightType);
    let flightsProgStage = [];
    progressionStage.stages.forEach((stage) => {
      const stageFlights = stage ? stage.flightTypeMap : {};
      if (progression.progressionType === ProgressionType.SingleTreatmentProgression) {
        const treatmentFlights = Object.keys(stageFlights).filter(
          (flightName2) => stageFlights[flightName2] === FlightType.Treatment
        );
        treatmentFlights.forEach((fl) => {
          const controlFlight = progression.flights.find(
            (flight) => compareIgnoreCase(flight.name, `${fl}${getControlFlightSuffix()}`)
          );
          if (!stageFlights[`${fl}${getControlFlightSuffix()}`] && controlFlight)
            stageFlights[`${fl}${getControlFlightSuffix()}`] = controlFlight.type;
        });
      }
      flightsProgStage = flightsProgStage.concat(Object.keys(stageFlights).find((key) => stageFlights[key] === flightType));
    });
    const flightName = _.uniq(flightsProgStage)[0];
    return flights.find((flight) => flight.name === flightName);
  }
  addControlFlights(progression, progressionSteps) {
    let controlFlights = [];
    if (progression.progressionType === ProgressionType.SingleTreatmentProgression) {
      progressionSteps.forEach((step) => {
        const stageFlights = step.flightTypeMap;
        const customFlightsStep = Object.keys(stageFlights).filter(
          (flightName) => stageFlights[flightName] === FlightType.CustomControl
        );
        customFlightsStep.forEach((fl) => {
          if (!step.flightTrafficMap[fl]) {
            const controlFlight = progression.flights.find((flight) => compareIgnoreCase(flight.name, fl));
            if (!!controlFlight) {
              controlFlights = [...controlFlights, controlFlight];
            }
          }
        });
      });
    }
    return controlFlights;
  }
  getFlightsInProgression(progression, flightType, initialProgressionFlights = false) {
    if (!progression || !progression.flights || progression.flights.length === 0 || progression.flights.filter((f) => f.type === flightType).length === 0) {
      return [];
    }
    let progressionFlights = progression.flights;
    if (initialProgressionFlights) {
      progressionFlights = progression.flights.filter((flight) => flight.isInitialProgressionFlight);
    }
    return progressionFlights.filter((f) => f.type === flightType);
  }
  getAllFlightsInProgression(progression) {
    if (!progression || !progression.flights || progression.flights.length === 0) {
      return [];
    }
    return progression.flights.filter((flight) => flight.isInitialProgressionFlight);
  }
  getIsolationGroupsInProgression(progression, index = 0) {
    var _a;
    if (progression && progression.filteredProgressionStages && progression.filteredProgressionStages.length > 0) {
      return ((_a = progression.filteredProgressionStages[index]) == null ? void 0 : _a.isolationGroups) || [];
    }
    return [];
  }
  getFlightsInProgressionStage(progression, stages) {
    if (!progression || !progression.flights || progression.flights.length === 0 || !stages || stages.length === 0) {
      return [];
    }
    let flightNames = this.getFlightNamesInProgressionStage(stages);
    return progression.flights.filter((f) => containsIgnoreCase(flightNames, f.name));
  }
  getFlightsInProgressionStageWithControlFlights(progression, stages) {
    let flights = this.getFlightsInProgressionStage(progression, stages);
    flights = flights.concat(this.addControlFlights(progression, stages));
    return _.uniqBy(flights, "name");
  }
  getFlightNamesInProgressionStage(stages) {
    if (!stages || stages.length === 0) {
      return [];
    }
    let flightNames = [];
    stages.forEach((stage) => {
      for (let key in stage.flightTypeMap) {
        if (!(key in stage.flightTrafficMap)) {
          stage.flightTrafficMap[key] = 0;
        }
      }
      if (!!stage.flightTrafficMap) {
        flightNames = flightNames.concat(Object.keys(stage.flightTrafficMap));
      }
    });
    return _.uniq(flightNames);
  }
  getIfFlightsChanged(initialFlights, finalFlights) {
    const flightsInitial = initialFlights.map((fl) => fl.name);
    const flightsFinal = finalFlights.map((fl) => fl.name);
    return _.isEqual(flightsInitial, flightsFinal);
  }
  // Get the total traffic percentages for the input traffic steps
  getAggregatedTrafficInProgressionStage(stages) {
    return stages.map((stage) => {
      return this.getAggregatedTrafficInTrafficStepForFlightType(stage, null);
    });
  }
  // Get the total traffic % based on whether it is single treatment rollout (only count treatment) or ABn (count all flights)
  getAggregatedTrafficInTrafficStep(trafficStep, trafficDistributionType) {
    const flightTypeFilter = trafficDistributionType === TrafficDistributionType.SingleTreatmentMirrorControl ? FlightType.Treatment : null;
    return this.getAggregatedTrafficInTrafficStepForFlightType(trafficStep, flightTypeFilter);
  }
  // Get the total traffic % for a step with an optional FlightType filter
  getAggregatedTrafficInTrafficStepForFlightType(trafficStep, filterToType) {
    if (!trafficStep.flightTrafficMap) {
      return 0;
    }
    let traffic = 0;
    _.each(Object.keys(trafficStep.flightTrafficMap), (flight) => {
      if (filterToType === null || filterToType === trafficStep.flightTypeMap[flight]) {
        traffic += trafficStep.flightTrafficMap[flight];
      }
    });
    return CommonUtilsInstance.roundTo(traffic, 1);
  }
  showMultipleFlights(progression) {
    return !EnvironmentService.isUnifiedView && progression.progressionUserInterfaceType && progression.progressionUserInterfaceType === ProgressionUserInterfaceType.HorizontalCardsWithFlightSet;
  }
  filterOutSeedFinderSteps(trafficSteps) {
    if (!!trafficSteps[0] && !!trafficSteps[0].stepTypes && trafficSteps[0].stepTypes[0] === "SeedFinder") {
      return trafficSteps.slice(1);
    }
    return trafficSteps;
  }
  getStageTreatmentFlight(progressionSteps) {
    let flights = [];
    progressionSteps.forEach((step) => {
      flights = flights.concat(Object.keys(step.flightTypeMap).find((key) => step.flightTypeMap[key] === FlightType.Treatment));
    });
    flights = _.uniq(flights);
    return flights[0];
  }
  getStageControlFlight(progressionSteps) {
    let flights = [];
    progressionSteps.forEach((step) => {
      flights = flights.concat(
        // @ts-ignore
        Object.keys(step.flightTypeMap).find((key) => step.flightTypeMap[key] === FlightType.CustomControl)
      );
    });
    flights = _.uniq(flights);
    return flights[0];
  }
  getLastNonNewTraffic(stages, treatmentFlightName, progressionType) {
    let filteredStages = this.filterNonTrafficSteps(stages);
    let nonNewStages = filteredStages.filter((stage) => stage.state.toLowerCase() !== ExperimentStates.NEW);
    if (!!nonNewStages.length && nonNewStages.length > 0) {
      let lastNonNewStep = nonNewStages[nonNewStages.length - 1];
      if (progressionType === ProgressionType.SingleTreatmentProgression) {
        return lastNonNewStep.flightTrafficMap[treatmentFlightName];
      }
      let trafficInLastNonNewStep = 0;
      _.each(lastNonNewStep.flightTrafficMap, (val, key) => {
        trafficInLastNonNewStep += val;
      });
      return +trafficInLastNonNewStep.toFixed(3);
    }
    return 0;
  }
  covertTrafficStep(originalTrafficSteps, trafficDistributionType) {
    let trafficStepsConverted = [];
    originalTrafficSteps.forEach((trafficStep) => {
      const newTrafficStep = {
        isEnabled: true,
        stepTypes: trafficStep.stepTypes,
        state: trafficStep.state,
        flightTrafficMap: ProgressionUtilsInstance.convertFlightTrafficMap(trafficStep.flightTrafficMap),
        trafficPercentage: ProgressionUtilsInstance.getAggregatedTrafficInTrafficStep(trafficStep, trafficDistributionType)
      };
      trafficStepsConverted.push(newTrafficStep);
    });
    return trafficStepsConverted;
  }
  IsStudioProgression(progression, featureId) {
    return EnvironmentService.isUnifiedView && progression.id === featureId && progression.name === studioProgression;
  }
  supportsPromotingFlights(progression) {
    return progression.progressionType === ProgressionType.ABnProgression;
  }
  supportEditingTrafficSteps(progression) {
    return progression.progressionType !== ProgressionType.OverrideSetProgression;
  }
  latestFlightAllocationId(progressionStage, flightName) {
    let latestFlightAllocationId = NaN;
    if (ProgressionStageStateUtilsInstance.isRunning(progressionStage)) {
      let lastStageWithFlightAllocation = _.findLast(progressionStage.stages, (stage) => {
        return !!stage.flightAllocationIdsMap && !!stage.flightAllocationIdsMap[flightName];
      });
      if (!!lastStageWithFlightAllocation) {
        latestFlightAllocationId = lastStageWithFlightAllocation.flightAllocationIdsMap[flightName];
      }
    }
    return latestFlightAllocationId;
  }
  // TODO revisit - RelativePosition
  getAddNewProgressionStagePosition(beforeOrAfter, stageIndex) {
    return beforeOrAfter === 0 ? stageIndex : stageIndex + 1;
  }
  getCreateProgressionStageConfig(progression, state) {
    const treatmentFlight = ProgressionUtilsInstance.getFlightInProgression(progression, FlightType.Treatment, true);
    const controlFlight = ProgressionUtilsInstance.getFlightInProgression(progression, FlightType.CustomControl, true);
    let treatmentFlightName = !!treatmentFlight ? treatmentFlight.name : null;
    let controlFlightName = !!controlFlight ? controlFlight.name : null;
    return {
      // @ts-ignore
      Id: void 0,
      Name: state.progressionStageName,
      Description: state.progressionStageName,
      TrafficFilters: TrafficFilterUtilInstance.getSelectedTrafficFilters(state.selectedTrafficFilters),
      Stages: this.getExperimentStageConfiguration(
        // @ts-ignore
        progression.trafficDistributionType,
        treatmentFlightName,
        controlFlightName,
        this.getAllFlightsInProgression(progression).map((f) => f.name),
        state.trafficSteps.filter((s) => !!s.trafficPercentage)
      )
    };
  }
  getProgressionSettingsType(progressionType) {
    if (!progressionType) {
      return ProgressionSettingsType.SingleTreatmentProgressionSettings;
    }
    switch (progressionType) {
      case ProgressionType.ABnProgression:
        return ProgressionSettingsType.ABnProgressionSettings;
      case ProgressionType.OverrideSetProgression:
        return ProgressionSettingsType.OverrideSetProgressionSettings;
      default:
        return ProgressionSettingsType.SingleTreatmentProgressionSettings;
    }
  }
  findCloneProgression(progressionCloneGroups, progressionId) {
    if (!progressionCloneGroups || !progressionId) {
      return null;
    }
    const { key, index } = findProgressionInProgressionCloneGroups(progressionId, progressionCloneGroups);
    if (!key) {
      return null;
    }
    const progressionSequence = progressionCloneGroups[key];
    return progressionSequence.length > index + 1 ? progressionSequence[index + 1] : null;
  }
  findClonedFromProgression(progressionCloneGroups, progression) {
    if (!progressionCloneGroups || !progression) {
      return null;
    }
    return getProgressionInProgressionCloneGroups(progression.clonedFromId, progressionCloneGroups);
  }
  iterateProgressionDisableReasons(progressionCloneGroups, progression, featureId) {
    const disableReasons = [];
    if (
      // @ts-ignore
      progression.configProviderInfo.status === AsyncRequestStatus.Pending || // @ts-ignore
      progression.configProviderInfo.status === AsyncRequestStatus.Completed || // @ts-ignore
      progression.configProviderInfo.status === AsyncRequestStatus.Failed
    ) {
      disableReasons.push(
        "The progression has been migrated to ECS where any further changes to the stage must take place."
        /* disabledByProgressionMigration */
      );
    } else {
      const clone = this.findCloneProgression(progressionCloneGroups, progression.id);
      const clonedFromProgression = this.findClonedFromProgression(progressionCloneGroups, progression);
      if (!!clone) {
        disableReasons.push(
          "Progression is already Iterated."
          /* disabledByAlreadyIterated */
        );
      }
      if (!!clonedFromProgression && !isProgressionStateNotRunning(clonedFromProgression)) {
        disableReasons.push(
          "The parent progression is still Running."
          /* disabledByParentIsRunning */
        );
      }
      if (this.IsStudioProgression(progression, featureId)) {
        disableReasons.push(
          "Migrated Studio progressions can not be iterated."
          /* disabledByStudioProgression */
        );
      }
    }
    return disableReasons;
  }
  pickAWinnerDisableReasons(progressionCloneGroups, progression, isAutoGeneratedIsolationGroup, featureId) {
    const disableReasons = this.iterateProgressionDisableReasons(progressionCloneGroups, progression, featureId);
    if (!isAutoGeneratedIsolationGroup) {
      disableReasons.push("Promote flight is not supported for progression using existing isolation group");
    } else if (isProgressionNotStarted(progression)) {
      disableReasons.push("Winning flight can be picked only after starting the progression");
    }
    return disableReasons;
  }
  getProgressionStageGatesWithDescendants(stage) {
    if (stage.gates && gatingUtils.isGateCheckCompleted(stage.gates)) {
      let allGates = stage.gates.data || [];
      _.each(stage.stages, (expStage) => {
        if (expStage.gates && expStage.gates.data) {
          allGates.push(...expStage.gates.data);
        }
      });
      const filteredGates = _.filter(
        allGates,
        (gate) => ProgressionStageStateUtilsInstance.canStart(stage) && this.isOperationGated(gate, OperationCheckTypes.Start) || ProgressionStageStateUtilsInstance.canStop(stage) && this.isOperationGated(gate, OperationCheckTypes.Stop)
      );
      return {
        status: stage.gates.status,
        data: filteredGates
      };
    }
    return null;
  }
  IsAnyProgressionRunningOrStopping(progressionCloneGroups) {
    let anyRunningOrStopping = false;
    _.forOwn(progressionCloneGroups, (progressions) => {
      anyRunningOrStopping = anyRunningOrStopping || _.some(progressions, (p) => isProgressionRunningOrStopping(p));
    });
    return anyRunningOrStopping;
  }
  isProgressionHideAllowed(progression, pendingApprovalGates) {
    return !!progression.state.State && isProgressionNotStarted(progression) && !(pendingApprovalGates && pendingApprovalGates.length !== 0);
  }
  isProgressionArchiveAllowed(progression, pendingApprovalGates) {
    return !!progression.state.State && !isProgressionRunningOrStopping(progression) && !(pendingApprovalGates && pendingApprovalGates.length !== 0);
  }
  isProgressionEditable(progression) {
    return !gatingUtils.hasWaitingGates(progression.gates);
  }
  isProgressionMigrationButtonShowUp(mdsFlightControl, progression) {
    var _a;
    return !!((_a = mdsFlightControl.ConfigProviderSettings) == null ? void 0 : _a.EnableConfigProviderMigration) && progression.progressionType === ProgressionType.SingleTreatmentProgression && !progression.trafficAllocation && // @ts-ignore
    (progression.configProviderInfo.status === AsyncRequestStatus.NotStarted || // @ts-ignore
    progression.configProviderInfo.status === AsyncRequestStatus.Failed);
  }
  isProgressionMigrateAllowed(progression, pendingApprovalGates, progressionGroup) {
    return progression.state.State === ExperimentStates.RUNNING && isProgressionStageRunningAt100Percent(progression) && !(pendingApprovalGates && pendingApprovalGates.length !== 0) && !this.hasPendingIteration(progression, progressionGroup);
  }
  hasPendingIteration(progression, progressionGroup) {
    let hasPendingIteration = false;
    let allStages = [];
    if (!!progressionGroup) {
      _.map(progressionGroup, (p) => {
        _.map(p.filteredProgressionStages, (stage) => {
          allStages.push(stage);
        });
      });
    }
    progression.filteredProgressionStages.forEach((stage) => {
      let progressionStageState = stage.state.State;
      let clonedFromStageState = stage.clonedFromProgressionStage && stage.clonedFromProgressionStage.state.State;
      let restartedFromStageState = stage.restartedFrom && stage.restartedFrom.state.State;
      if (
        // @ts-ignore
        [ExperimentStates.RUNNING, ExperimentStates.STARTING].includes(clonedFromStageState) && ![ExperimentStates.RUNNING, ExperimentStates.STARTING].includes(progressionStageState) || // @ts-ignore
        [ExperimentStates.RUNNING, ExperimentStates.STARTING].includes(restartedFromStageState) && ![ExperimentStates.RUNNING, ExperimentStates.STARTING].includes(progressionStageState)
      ) {
        hasPendingIteration = true;
      }
      let iteratedToStages = allStages.filter((s) => s.restartedFromId === stage.id || s.clonedFromId === stage.id);
      _.map(iteratedToStages, (iteratedToStage) => {
        let iteratedToStageState = iteratedToStage.state.State;
        if ([ExperimentStates.RUNNING, ExperimentStates.STARTING].includes(progressionStageState) && ![ExperimentStates.RUNNING, ExperimentStates.STARTING].includes(iteratedToStageState)) {
          hasPendingIteration = true;
        }
      });
    });
    return hasPendingIteration;
  }
  getProgressionTitle(progression) {
    return `${this.getProgressionTypePrefix(progression)}${this.getTemplateName(progression)}: ${progression.name}`;
  }
  isCreatedUsingAutoGeneratedIsolationGroup(progression) {
    return !progression.trafficAllocation;
  }
  getSelectedTemplateStages(progressionSelection) {
    if (!!progressionSelection.selectedProgressionTemplateName) {
      return progressionSelection.progressionTemplateOptions[progressionSelection.selectedProgressionTemplateId].stages || [];
    }
    return [];
  }
  hasSeedFinderStep(stepTypes) {
    return containsIgnoreCase(stepTypes, ExperimentStepType.SeedFinder);
  }
  // Get **only** progression stages that have traffic (e.g. no SeedFinder stages)
  filterNonTrafficSteps(trafficSteps) {
    return _.filter(trafficSteps, (step) => !this.hasSeedFinderStep(step.stepTypes));
  }
  isInvalidTrafficPercent(trafficSteps) {
    const invalidTraffic = trafficSteps.filter(
      (traffic) => !traffic || ProgressionUtilsInstance.isInvalidTraffic(traffic.trafficPercentage)
    );
    return invalidTraffic.length > 0;
  }
  getCandidateAutoStartStageId(progression) {
    if (progression.filteredProgressionStages && progression.filteredProgressionStages.length > 0) {
      const firstStage = progression.filteredProgressionStages[0];
      if (ProgressionStageStateUtilsInstance.canStart(firstStage)) {
        return firstStage.id;
      }
    }
    return null;
  }
  // Currently this method returns 3 status code:
  // enable;
  // disabled due to new iteration already exists;
  // disabled due to pending approval request for this stage;
  checkProgressionStageEditAvailability(progressionStage, cloneGroups) {
    let validationResult = 0;
    if (!!cloneGroups) {
      Object.keys(cloneGroups).forEach((groupKey) => {
        cloneGroups[groupKey].forEach((progression) => {
          progression.filteredProgressionStages.forEach((stage) => {
            if (!stage.isHidden && (stage.restartedFromId === progressionStage.id || stage.clonedFromId === progressionStage.id)) {
              validationResult = 1;
            }
            if (stage.id === progressionStage.id) {
              let updateBlockingGates = gatingUtils.getUpdateBlockingGates(progression, stage);
              if (_.some(updateBlockingGates)) {
                validationResult = 2;
              }
            }
            if (progressionStage.state && progressionStage.state.State && (compareIgnoreCase(progressionStage.state.State, ExperimentStates.MIGRATING) || compareIgnoreCase(progressionStage.state.State, ExperimentStates.MIGRATIONSUCCEEDED) || compareIgnoreCase(progressionStage.state.State, ExperimentStates.MIGRATIONFAILED))) {
              validationResult = 3;
            }
          });
        });
      });
    }
    return validationResult;
  }
  // The property FlightTrafficMap in ITrafficStep and ITrafficStepEdit has different value types: number VS string
  // This method is a helper convert method
  // Going forward, we need to normalize FlightTrafficMap
  convertFlightTrafficMap(trafficStepMap) {
    let trafficStepEditMap = {};
    if (trafficStepMap) {
      Object.entries(trafficStepMap).forEach(([key, value]) => {
        trafficStepEditMap[key] = value.toString();
      });
    }
    return trafficStepEditMap;
  }
  isOperationGated(gate, operationType) {
    return gatingUtils.isOperationGated(gate, operationType);
  }
  getTemplateName(progression) {
    return progression.progressionSelection ? progression.progressionSelection.selectedProgressionTemplateName : progression.templateName;
  }
  getProgressionTypePrefix(progression) {
    switch (progression.progressionType) {
      case ProgressionType.ABnProgression:
        return "[A/B/n Experiment] ";
      case ProgressionType.SingleTreatmentProgression:
      case ProgressionType.OverrideSetProgression:
        return "[Feature Rollout] ";
      default:
        return "";
    }
  }
  getTrafficMap(treatmentName, controlName, pendingStage) {
    let map = {};
    if (!!controlName && this.isControlFlightSupported(pendingStage)) {
      map[controlName] = pendingStage;
    }
    if (!!treatmentName) {
      map[treatmentName] = pendingStage;
    }
    return map;
  }
  getTrafficMapForEqualDivide(flightNames, pendingStage) {
    let map = {};
    if (!flightNames || flightNames.length <= 0) {
      return map;
    }
    let totalFlights = flightNames.length;
    _.forEach(flightNames, (flightName) => {
      map[flightName] = CommonUtilsInstance.roundTo(pendingStage / totalFlights, 1);
    });
    return map;
  }
  getStageStepType(stage) {
    var _a;
    if (!stage || !((_a = stage.stepTypes) == null ? void 0 : _a[0])) {
      return "AB";
    }
    return stage.stepTypes[0];
  }
  // Sorts pending traffic steps by the traffic percentage in increasing order. Prioritizes SeedFinder steps.
  sortExperimentStages(trafficSteps, treatmentFlight) {
    const nonNewSteps = trafficSteps.filter((s) => !ExperimentStepStates.isNew(s.state));
    const newSteps = trafficSteps.filter((s) => ExperimentStepStates.isNew(s.state));
    const sortedSeedFinder = newSteps.filter((step) => this.hasSeedFinderStep(step.stepTypes)).sort(
      (a, b) => !!treatmentFlight && !!a.flightTrafficMap && !!b.flightTrafficMap && treatmentFlight in a.flightTrafficMap && treatmentFlight in b.flightTrafficMap ? +a.flightTrafficMap[treatmentFlight] - +b.flightTrafficMap[treatmentFlight] : a.trafficPercentage - b.trafficPercentage
    );
    const sortedTrafficStages = newSteps.filter((step) => !this.hasSeedFinderStep(step.stepTypes)).sort(
      (a, b) => !!treatmentFlight && !!a.flightTrafficMap && !!b.flightTrafficMap && treatmentFlight in a.flightTrafficMap && treatmentFlight in b.flightTrafficMap ? +a.flightTrafficMap[treatmentFlight] - +b.flightTrafficMap[treatmentFlight] : a.trafficPercentage - b.trafficPercentage
    );
    return nonNewSteps.concat(sortedSeedFinder, sortedTrafficStages);
  }
  checkIfTrafficStepsChanged(initialTrafficSteps, latestTrafficSteps) {
    return _.isEqual(initialTrafficSteps, latestTrafficSteps);
  }
  getFlightUpdateInExperimentEdit(flightMap, flightTypeMap) {
    let stepType = ExperimentStepType.AB;
    const controlFlights = _.filter(flightMap, (value, key) => flightTypeMap[key] === FlightType.CustomControl);
    const isDataCollection = controlFlights.length === 0 || _.every(controlFlights, (flightName) => +flightMap[flightName] === 0);
    if (isDataCollection) {
      stepType = ExperimentStepType.DataCollection;
    }
    let updatedFlightMap = {};
    for (let flightName in flightMap) {
      if (stepType === ExperimentStepType.AB) {
        updatedFlightMap[flightName] = flightMap[flightName];
      } else if (stepType === ExperimentStepType.DataCollection) {
        if (flightTypeMap[flightName] == FlightType.Treatment) {
          updatedFlightMap[flightName] = flightMap[flightName];
        }
      }
    }
    return updatedFlightMap;
  }
  getTrafficUpdatedOnSelectedFlightChange(trafficMap, treatmentFlight, controlFlight, expandedFlights) {
    var _a;
    let newTrafficMap = {};
    for (let key in trafficMap) {
      if (!!treatmentFlight && ((_a = expandedFlights == null ? void 0 : expandedFlights.find((f) => f.name == key)) == null ? void 0 : _a.type) == FlightType.Treatment) {
        newTrafficMap[treatmentFlight] = trafficMap[key];
      } else if (!!controlFlight) {
        newTrafficMap[controlFlight] = trafficMap[key];
      }
    }
    return newTrafficMap;
  }
  getFlightTrafficMapOnSelectedFlightChange(trafficMap, selectedFlights, expandedFlights) {
    var _a, _b;
    let treatmentFlight = (_a = selectedFlights.find((f) => f.type == FlightType.Treatment)) == null ? void 0 : _a.name;
    let controlFlight = (_b = selectedFlights.find((f) => f.type == FlightType.CustomControl)) == null ? void 0 : _b.name;
    let newFlightTrafficMap = [];
    _.forEach(trafficMap, (traffiMap, i) => {
      newFlightTrafficMap[i] = this.getTrafficUpdatedOnSelectedFlightChange(
        traffiMap,
        // @ts-ignore
        treatmentFlight,
        controlFlight,
        expandedFlights
      );
    });
    return newFlightTrafficMap;
  }
  getTrafficStepsOnSelectedFlightChange(trafficSteps, selectedFlights, expandedFlights) {
    var _a, _b;
    let treatmentFlight = (_a = selectedFlights.find((f) => f.type == FlightType.Treatment)) == null ? void 0 : _a.name;
    let controlFlight = (_b = selectedFlights.find((f) => f.type == FlightType.CustomControl)) == null ? void 0 : _b.name;
    let newTrafficSteps = [];
    trafficSteps.forEach((trafficStep) => {
      const newTrafficStep = __spreadProps(__spreadValues({}, trafficStep), {
        flightTrafficMap: this.getTrafficUpdatedOnSelectedFlightChange(
          trafficStep.flightTrafficMap,
          // @ts-ignore
          treatmentFlight,
          controlFlight,
          expandedFlights
        )
      });
      newTrafficSteps.push(newTrafficStep);
    });
    return newTrafficSteps;
  }
  sortAllExperimentStages(trafficSteps, treatmentFlight) {
    const sortedSeedFinder = trafficSteps.filter((step) => this.hasSeedFinderStep(step.stepTypes)).sort(
      (a, b) => !!treatmentFlight && !!a.flightTrafficMap && !!b.flightTrafficMap && treatmentFlight in a.flightTrafficMap && treatmentFlight in b.flightTrafficMap ? +a.flightTrafficMap[treatmentFlight] - +b.flightTrafficMap[treatmentFlight] : a.trafficPercentage - b.trafficPercentage
    );
    const sortedTrafficStages = trafficSteps.filter((step) => !this.hasSeedFinderStep(step.stepTypes)).sort(
      (a, b) => !!treatmentFlight && !!a.flightTrafficMap && !!b.flightTrafficMap && treatmentFlight in a.flightTrafficMap && treatmentFlight in b.flightTrafficMap ? +a.flightTrafficMap[treatmentFlight] - +b.flightTrafficMap[treatmentFlight] : a.trafficPercentage - b.trafficPercentage
    );
    return sortedSeedFinder.concat(sortedTrafficStages);
  }
  getTrafficPercentages(trafficSteps, showIteration = false) {
    const sortedExpStages = showIteration ? this.sortAllExperimentStages(trafficSteps) : this.sortExperimentStages(trafficSteps);
    return sortedExpStages.filter((step) => !!step.trafficPercentage).map((step) => step.trafficPercentage);
  }
  // Get the rest of traffic steps after delete the #index step
  getTrafficStepsInStepDelete(trafficSteps, index) {
    if (!!trafficSteps[0] && !!trafficSteps[0].stepTypes && this.hasSeedFinderStep(trafficSteps[0].stepTypes)) {
      index = index + 1;
    }
    return trafficSteps.slice(0, index).concat(trafficSteps.slice(index + 1));
  }
  getFirstProgressionInProgressionIterationChain(progression) {
    while (!!progression.clonedFromProgression) {
      progression = progression.clonedFromProgression;
    }
    return progression;
  }
  getProgressionMigrationSubmittingState(progressionCloneGroups, progressionId) {
    let progressionMigrationSubmittingState = {
      status: AsyncRequestStatus.NotStarted,
      data: null
    };
    if (!!progressionCloneGroups && !!progressionId) {
      Object.keys(progressionCloneGroups).map((progressionKey) => {
        progressionCloneGroups[progressionKey].map((progression) => {
          if (progression.id === progressionId) {
            progressionMigrationSubmittingState = progression.migrationSubmittingState;
          }
        });
      });
    }
    return progressionMigrationSubmittingState;
  }
  getPendingApprovalRequestsForProgression(featurePendingApprovalRequests, progression) {
    let progressionStageIds = progression.filteredProgressionStages.map((stage) => stage.id);
    var result = featurePendingApprovalRequests == null ? void 0 : featurePendingApprovalRequests.filter(
      (request) => request.EntityId.includes(progression.id) || _.some(progressionStageIds, (Id) => {
        return request.EntityId.includes(Id);
      })
    );
    return result;
  }
}
const ProgressionUtilsInstance = new ProgressionUtils();
const getControlFlightSuffix = () => "cf";
const GuidLength = 32;
const createFeatureRequest = (featureMetadata, flightList) => {
  const flights = getExpandedFlightList(flightList);
  let postData = {
    Description: featureMetadata.description,
    IsHidden: false,
    Flights: flights.map((f) => {
      return {
        Description: f.name,
        FlightType: f.type === FlightType.Treatment ? "Treatment" : "CustomControl",
        Name: f.name,
        TreatmentVariables: f.treatmentVariables.map((tv) => {
          return {
            Key: tv.name,
            Namespace: featureMetadata.treatmentVariableNamespace,
            Type: tv.type === TreatmentVariableType.Boolean ? "boolean" : tv.type === TreatmentVariableType.Number ? "int" : "string",
            Value: tv.value
          };
        }),
        IsolationGroups: featureUtilsV2Instance.getFlightIsolationGroups(
          featureMetadata.isAutoGeneratedIsolationGroup,
          featureMetadata.autoGeneratedIsolationGroup,
          featureMetadata.isolationGroups
        ),
        // @ts-ignore
        Composition: featureUtilsV2Instance.getFlightComposition(featureMetadata.enableComboFlight, f.composition)
      };
    }),
    WorkspaceId: featureMetadata.workspaceId,
    ManagementGroup: featureMetadata.managementGroup,
    Tenant: featureMetadata.controlTowerTenant,
    Name: featureMetadata.name,
    Owners: featureMetadata.owners,
    // @ts-ignore
    AssignmentUnit: featureMetadata.isAutoGeneratedIsolationGroup ? featureMetadata.selectedAssignmentUnit : null,
    // @ts-ignore
    Extensions: _.some(featureMetadata.customProperties) ? featureMetadata.customProperties : null,
    // @ts-ignore
    Subscriptions: featureMetadata.enableSubscriptionSelection && featureMetadata.isAutoGeneratedIsolationGroup ? featureMetadata.selectedSubscriptions : null
  };
  return postData;
};
const createFeatureRequestFormik = (formData, featureMetadata) => {
  const flights = getExpandedFlightList(formData.flightList);
  let postData = {
    Description: formData.description,
    IsHidden: false,
    Flights: flights.map((f) => {
      return {
        Description: f.name,
        FlightType: f.type === FlightType.Treatment ? "Treatment" : "CustomControl",
        Name: f.name,
        TreatmentVariables: f.treatmentVariables.map((tv) => {
          return {
            Key: tv.name,
            Namespace: featureMetadata.showVNextProgressionPage ? tv.namespace : featureMetadata.treatmentVariableNamespace,
            Type: tv.type === TreatmentVariableType.Boolean ? "boolean" : tv.type === TreatmentVariableType.Number ? "int" : "string",
            Value: tv.value
          };
        }),
        IsolationGroups: featureUtilsV2Instance.getFlightIsolationGroups(
          formData.isolationGroupCategorySelected === IsolationGroupCategoryOption.autoGeneratedIsolationGroup,
          featureMetadata.autoGeneratedIsolationGroup,
          formData.isolationGroups
        ),
        // @ts-ignore
        Composition: featureUtilsV2Instance.getFlightComposition(featureMetadata.enableComboFlight, f.composition)
      };
    }),
    WorkspaceId: featureMetadata.workspaceId,
    ManagementGroup: featureMetadata.managementGroup,
    Tenant: featureMetadata.controlTowerTenant,
    Name: formData.name,
    Owners: formData.owners,
    Tags: featureMetadata.tags,
    // @ts-ignore
    AssignmentUnit: formData.isolationGroupCategorySelected === IsolationGroupCategoryOption.autoGeneratedIsolationGroup ? formData.selectedAssignmentUnit : null,
    // @ts-ignore
    Extensions: _.some(formData.customProperties) ? formData.customProperties : null,
    // @ts-ignore
    Subscriptions: featureMetadata.enableSubscriptionSelection && formData.isolationGroupCategorySelected === IsolationGroupCategoryOption.autoGeneratedIsolationGroup ? formData.selectedSubscriptions : null
  };
  return postData;
};
const getExtensionsProperties = (feature, propertyName, defaultValue) => {
  if (!!feature && !!feature.Extensions && feature.Extensions[propertyName] !== null && feature.Extensions[propertyName] !== void 0) {
    return feature.Extensions[propertyName];
  }
  return defaultValue;
};
const parseFlightList = (frBackend, IsControlFlightNameEditable) => {
  let allFlights = frBackend.Flights;
  const flightList = {
    // @ts-ignore
    flights: (allFlights == null ? void 0 : allFlights.map((f) => {
      return {
        isControlEnabled: !!IsControlFlightNameEditable ? false : frBackend.Flights.filter((f1) => f1.Name === `${f.Name}${getControlFlightSuffix()}`).length > 0,
        isCreated: true,
        name: f.Name,
        treatmentVariables: _.map(f.TreatmentVariables, (tv) => {
          return {
            name: tv.Key,
            type: !!tv.Type && tv.Type.toLowerCase() === "boolean" ? TreatmentVariableType.Boolean : !!tv.Type && tv.Type.toLowerCase() === "int" ? TreatmentVariableType.Number : TreatmentVariableType.String,
            value: tv.Value,
            namespace: tv.Namespace
          };
        }),
        isValidating: false,
        isolationGroups: f.IsolationGroups,
        type: compareIgnoreCase(f.FlightType || "", "treatment") ? FlightType.Treatment : FlightType.CustomControl,
        isCombo: !!f.Composition && f.Composition.length > 0,
        composition: _.map(f.Composition, (c) => c.FlightName)
      };
    })) || [],
    explicitControlFlights: IsControlFlightNameEditable
  };
  return flightList;
};
const parseFeatureInfo = (feature, IsControlFlightNameEditable, userHasWritePermission) => {
  let isolationGroups = [];
  if (!!feature.Flights && !!feature.Flights.length) {
    isolationGroups = feature.Flights[0].IsolationGroups;
  }
  const autoGenIsolationGroup = feature.FeatureRolloutMetadata && feature.FeatureRolloutMetadata.AutoGeneratedIsolationGroupId;
  const makeLegacyRolloutReadOnly = getExtensionsProperties(feature, "MakeLegacyRolloutReadOnly", false);
  const featureMetadata = {
    description: feature.Description,
    id: feature.Id,
    // @ts-ignore
    isInitialized: feature.IsExperimentInitialized,
    isHidden: feature.IsHidden || makeLegacyRolloutReadOnly,
    workspaceId: feature.WorkspaceId || EnvironmentService.getWorkspaceIdOrDefault(),
    managementGroup: feature.ManagementGroup,
    name: feature.Name,
    owners: feature.Owners,
    treatmentVariableNamespace: "",
    treatmentVariableNamespacePrefix: "",
    // @ts-ignore
    treatmentVariableEnabled: null,
    isolationGroups,
    isControlEnabledDefault: true,
    canDisableControlFlight: false,
    selectedAssignmentUnit: feature.AssignmentUnit,
    assignmentUnits: [],
    operationCheck: getDefaultCompletedOperationCheck(),
    isProgressionAllowed: getExtensionsProperties(feature, "IsProgressionAllowed", true),
    useLegacyRollout: getExtensionsProperties(feature, "UseLegacyRollout", false),
    legacyRolloutMigrated: getExtensionsProperties(feature, "LegacyRolloutMigrated", false),
    // @ts-ignore
    northstarFeatureDefinitionCopy: getExtensionsProperties(feature, "NorthstarFeatureDefinitionCopy", null),
    makeLegacyRolloutReadOnly,
    // @ts-ignore
    gatesMetadata: getExtensionsProperties(feature, "GateSetMetadata", null),
    canRestartProgressionStage: false,
    enableOverrideTargets: false,
    controlTowerTenant: feature.Tenant,
    enableEmergencyShutdown: false,
    enableSubscriptionSelection: false,
    // @ts-ignore
    selectedSubscriptions: feature.Subscriptions,
    subscriptionOptions: [],
    defaultSubscriptions: [],
    isFlightCountersEnabled: false,
    enableIsolationGroupSelection: false,
    isolationGroupOptions: [],
    // @ts-ignore
    isAutoGeneratedIsolationGroup: featureUtilsV2Instance.isAutoGeneratedIsolationGroup(isolationGroups, autoGenIsolationGroup),
    // @ts-ignore
    autoGeneratedIsolationGroup: autoGenIsolationGroup,
    enableComboFlight: false,
    customProperties: feature.Extensions || {},
    userHasWritePermission: userHasWritePermission || false,
    flightNameLengthReservedBySystem: 4,
    maxFlightNameLength: 20
  };
  const flightList = parseFlightList(feature, IsControlFlightNameEditable);
  return {
    featureMetadata,
    flightList
  };
};
const parseTrafficFilters = (trafficFilters, mdsFilters, checkIsRequiredFromMds = false, includeValuesForRemovedFilter = false) => {
  let trafficFilterDictionary = {
    trafficFilters: {}
  };
  _.forOwn(trafficFilters, (values, key) => {
    var _a, _b;
    let trafficFilterValues;
    if (!values) {
      trafficFilterValues = [
        {
          [OperatorConstants.In]: []
        }
      ];
    } else if (values.length > 0 && typeof values[0] === "string") {
      let valuesArray = values;
      trafficFilterValues = [
        {
          [OperatorConstants.In]: toLowerCaseArray(removeEmptyValues(valuesArray))
        }
      ];
    } else {
      trafficFilterValues = values;
    }
    const isRequired = checkIsRequiredFromMds ? (_a = MasterDataUtilInstance.getMdsFilter(mdsFilters, key)) == null ? void 0 : _a.IsRequired : false;
    const masterDataFilter = MasterDataUtilInstance.getMdsFilter(mdsFilters, key);
    let allowNoFilter = false;
    if (masterDataFilter !== null) {
      allowNoFilter = masterDataFilter.AllowNoFilter;
    }
    let mdsKey = (_b = CommonUtilsInstance.getMatchingKeyIgnoreCase(mdsFilters, key)) != null ? _b : key;
    trafficFilterDictionary.trafficFilters[mdsKey] = MasterDataUtilInstance.toTrafficFilter(
      key,
      mdsFilters,
      isRequired,
      true,
      allowNoFilter,
      trafficFilterValues,
      includeValuesForRemovedFilter
    );
  });
  return trafficFilterDictionary;
};
const nestRestartedFromStagesIntoProgressionStage = (stage, allStages) => {
  if (!!stage.restartedFromId) {
    const restartedFromStage = allStages.find((s) => s.id === stage.restartedFromId);
    stage.restartedFrom = restartedFromStage;
  }
};
const groupRestartedProgressionStages = (progressionStages) => {
  let groupedStages = _.cloneDeep(progressionStages);
  _.forEach(groupedStages, (stage) => {
    nestRestartedFromStagesIntoProgressionStage(stage, groupedStages);
  });
  return groupedStages;
};
const populateParents = (child, parent) => {
  child.clonedFromProgression = parent;
  if (!!child.filteredProgressionStages) {
    child.filteredProgressionStages.forEach((t) => {
      t.clonedFromProgressionStage = parent.filteredProgressionStages.find((pt) => pt.id === t.clonedFromId);
    });
  }
};
const constructProgressionCloneGroups = (progressions) => {
  let progressionGroups = {};
  progressions.filter((p) => !p.clonedFromId || !progressions.some((other) => other.id === p.clonedFromId)).forEach((p) => {
    progressionGroups[p.id] = [p];
    let child = CommonUtilsInstance.sortByDateString(
      progressions.filter((c) => c.clonedFromId === p.id),
      CommonUtilsInstance.getPropName(progressions[0], progressions[0].created),
      false
    )[0];
    while (!!child) {
      const parent = progressionGroups[p.id][progressionGroups[p.id].length - 1];
      populateParents(child, parent);
      progressionGroups[p.id].push(child);
      child = CommonUtilsInstance.sortByDateString(
        progressions.filter((c) => c.clonedFromId === child.id),
        CommonUtilsInstance.getPropName(progressions[0], progressions[0].created),
        false
      )[0];
    }
  });
  return progressionGroups;
};
const getOriginalProgression = (progression) => {
  let parent = progression;
  while (!!parent.clonedFromProgression) {
    parent = parent.clonedFromProgression;
  }
  return parent;
};
const areProgressionGroupsEqual = (first, second) => {
  const firstKeys = Object.keys(first);
  const secondKeys = Object.keys(second);
  if (!_.isEqual(new Set(firstKeys), new Set(secondKeys))) {
    return false;
  }
  for (let i = 0; i < firstKeys.length; ++i) {
    const key = firstKeys[i];
    const firstProgressions = first[key];
    const secondProgressions = second[key];
    if (firstProgressions.length !== secondProgressions.length) {
      return false;
    }
    if (!_.isEqual(
      firstProgressions.map((p) => p.id),
      secondProgressions.map((p) => p.id)
    )) {
      return false;
    }
  }
  return true;
};
const findProgressionInProgressionCloneGroups = (progressionId, progressionCloneGroups) => {
  let ret = { key: null, index: -1 };
  const keys = Object.keys(progressionCloneGroups || {});
  for (let i = 0; i < keys.length; ++i) {
    const key = keys[i];
    const progressions = progressionCloneGroups[key];
    let index = progressions.findIndex((p) => p.id === progressionId);
    if (index >= 0) {
      ret.key = key;
      ret.index = index;
      return ret;
    }
  }
  return ret;
};
const getProgressionInProgressionCloneGroups = (progressionId, progressionCloneGroups) => {
  let { key, index } = findProgressionInProgressionCloneGroups(progressionId, progressionCloneGroups);
  if (!key) {
    return null;
  }
  return progressionCloneGroups[key][index];
};
const getProgressionTargetSequence = (progressionList) => {
  let seqOfProgressionTargets = [];
  let i = 0;
  let j = 0;
  for (i = 0; i < progressionList.progressions.length; i++) {
    for (j = 0; j < progressionList.progressions[i].filteredProgressionStages.length; j++) {
      let id = progressionList.progressions[i].filteredProgressionStages[j].id;
      if (id.length >= GuidLength) {
        seqOfProgressionTargets.push(id);
      }
    }
  }
  return seqOfProgressionTargets;
};
const parseAssignmentUnitSelection = (assignmentUnitSelection) => {
  let assignmentUnits = [];
  if (assignmentUnitSelection) {
    const keys = Object.keys(assignmentUnitSelection);
    assignmentUnits = _.map(keys, (key) => {
      const value = assignmentUnitSelection[key];
      return {
        Id: key,
        DisplayName: value.DisplayName,
        IsDefault: value.IsDefault,
        IsHidden: value.IsHidden || false
      };
    });
  }
  return assignmentUnits;
};
const isFeatureDeleteAllowed = (progressionCloneGroups, overrides) => {
  let isFeatureDeleteAllowed2 = true;
  if (progressionCloneGroups && Object.keys(progressionCloneGroups).length > 0) {
    for (let key in progressionCloneGroups) {
      let progressions = progressionCloneGroups[key];
      for (let i = 0; i < progressions.length; i++) {
        if (!ProgressionUtilsInstance.isProgressionArchiveAllowed(progressions[i])) {
          isFeatureDeleteAllowed2 = false;
          break;
        }
      }
    }
  }
  if (!!overrides) {
    overrides.forEach((overrideSet) => {
      var _a;
      if (!!((_a = overrideSet == null ? void 0 : overrideSet.stages) == null ? void 0 : _a.length)) {
        overrideSet.stages.find((stage) => {
          var _a2;
          if (![ExperimentStates.NEW, ExperimentStates.COMPLETED].includes((_a2 = stage == null ? void 0 : stage.state) == null ? void 0 : _a2.toLowerCase())) {
            isFeatureDeleteAllowed2 = false;
          }
        });
      }
    });
  }
  return isFeatureDeleteAllowed2;
};
class ProgressionSelectionUtils {
  //todo: Use strong types
  getProgressionCreateRequest(rootFeatureId, progressionSelection, isAutoGeneratedIsolationGroup, userRequestedResalt = false, promoteFlight = false) {
    if (this.supportsMultipleFlights(progressionSelection)) {
      if (!_.some(progressionSelection.selectedFlights, (flight) => flight.type === FlightType.Treatment)) {
        const error = Error("You must choose at least one treatment flight to promote.");
        error.isUserError = true;
        throw error;
      }
    }
    let progressionSettingsType = progressionSelection.progressionSettingsType;
    let flights = [];
    if (progressionSettingsType === ProgressionSettingsType.OverrideSetProgressionSettings) {
      flights = _.map(
        progressionSelection.selectedFlights.filter((f) => f.type === FlightType.Treatment),
        (flight) => flight.name
      );
    } else {
      flights = _.map(progressionSelection.selectedFlights, (flight) => flight.name);
    }
    return {
      RootFeatureId: rootFeatureId,
      TrialTemplateId: progressionSelection.selectedProgressionTemplateId,
      Name: progressionSelection.progressionName,
      FlightNames: flights,
      ProgressionSettingsType: !!progressionSelection.progressionSettingsType ? ProgressionSettingsType[progressionSelection.progressionSettingsType] : ProgressionSettingsType[ProgressionSettingsType.SingleTreatmentProgressionSettings],
      TrafficFilters: TrafficFilterUtilInstance.getSelectedTrafficFilters(progressionSelection.selectedTrafficFilters, true),
      // @ts-ignore
      TrafficAllocationPercentage: isAutoGeneratedIsolationGroup ? null : progressionSelection.trafficAllocation,
      ResaltOnStart: userRequestedResalt,
      OnlyUseLastTrafficStep: promoteFlight
    };
  }
  selectProgressionTemplate(prevProgressionSelection, selectedTemplateId) {
    const cloned = _.cloneDeep(prevProgressionSelection);
    const selectedTemplate = cloned.progressionTemplateOptions[selectedTemplateId];
    return __spreadProps(__spreadValues({}, cloned), {
      selectedProgressionTemplateId: selectedTemplateId,
      selectedProgressionTemplateName: selectedTemplate.progressionTemplateName,
      initialTrafficFilters: _.cloneDeep(selectedTemplate.initialTrafficFilters),
      selectedTrafficFilters: _.cloneDeep(selectedTemplate.initialTrafficFilters),
      // @ts-ignore
      initialFreeFormTrafficFilters: !!selectedTemplate.initialFreeFormTrafficFilters ? _.cloneDeep(selectedTemplate.initialFreeFormTrafficFilters) : null,
      // @ts-ignore
      progressionName: prevProgressionSelection.progressionName || selectedTemplate.defaultProgressionName,
      stageTrafficFilterKeys: selectedTemplate.stageTrafficFilterKeys || [],
      allowAdditionalFilters: selectedTemplate.allowAdditionalFilters
    });
  }
  supportedProgressionSettingsTypes(progressionSelection, isAutoGeneratedIsolationGroup) {
    let progressionSettingsType = [];
    if (progressionSelection && progressionSelection.progressionTemplateOptions) {
      let progressionTemplates = CommonUtilsInstance.getValues(progressionSelection.progressionTemplateOptions);
      progressionTemplates.forEach((template) => {
        if (template.supportedProgressionSettingsTypes && template.supportedProgressionSettingsTypes.length > 0) {
          template.supportedProgressionSettingsTypes.forEach((supportType) => {
            if (isAutoGeneratedIsolationGroup || this.isCompatibleWithSharedIsolationGroup(supportType.id)) {
              progressionSettingsType.push(supportType);
            }
          });
        }
      });
      progressionSettingsType = _.uniqBy(progressionSettingsType, (pt) => pt.id);
    }
    return progressionSettingsType;
  }
  // TODO - revisit
  getProgressionSelectionFromState(progressionId, state) {
    let progressionSelection = null;
    if (!!progressionId) {
      const { key, index } = findProgressionInProgressionCloneGroups(progressionId, state.progressionCloneGroups);
      if (!!key && index > -1) {
        progressionSelection = state.progressionCloneGroups[key][index].progressionSelection;
      }
    } else {
      progressionSelection = state.progressionSelection;
    }
    return progressionSelection;
  }
  supportsMultipleFlights(progressionSelection) {
    return this.isABnProgression(progressionSelection);
  }
  supportsSingleTreatment(progressionSelection) {
    return progressionSelection.progressionSettingsType === ProgressionSettingsType.OverrideSetProgressionSettings;
  }
  supportsControlFlights(progressionSelection) {
    return progressionSelection.progressionSettingsType !== ProgressionSettingsType.OverrideSetProgressionSettings;
  }
  supportsPromotingFlight(progressionSelection) {
    return this.isABnProgression(progressionSelection);
  }
  selectionHasSeedFinderStep(template) {
    if (!template || !template.workflow || template.workflow.length === 0) {
      return false;
    }
    return _.some(
      template.workflow,
      (stage) => _.some(stage.steps, (step) => compareIgnoreCase(step.type, ExperimentStepType.SeedFinder))
    );
  }
  isCompatibleWithSharedIsolationGroup(progressionType) {
    return progressionType === ProgressionSettingsType.ABnProgressionSettings;
  }
  isABnProgression(progressionSelection) {
    return (progressionSelection == null ? void 0 : progressionSelection.progressionSettingsType) === ProgressionSettingsType.ABnProgressionSettings;
  }
}
const ProgressionSelectionUtilInstance = new ProgressionSelectionUtils();
class MasterDataUtils {
  constructor() {
    __publicField(this, "transformTicketCategoriesToComboboxOptions", (mdsCategories) => {
      let categories = [];
      if (!mdsCategories)
        return [];
      for (let i = 0; i < mdsCategories.Categories.length; i++) {
        let category = mdsCategories.Categories[i];
        if ("Enabled" in category && !category.Enabled) {
          continue;
        }
        categories.push({
          key: category.Category,
          text: category.Category,
          title: category.HelpContent,
          data: {
            vsoAreaPath: category.VSOAreaPath,
            driAlias: category.driAlias,
            ccAliases: category.ccAliases
          }
        });
      }
      return categories;
    });
  }
  getProgressionSelection(mdsTrafficFilters, mdsProgressionTemplates, mdsControlTowerExperience, mdsExperimentTemplates, flightList) {
    let progressionSelection = getDefaultProgressionSelectionTemplates();
    progressionSelection.progressionTemplateOptions = this.getProgressionTemplatesOptions(
      mdsTrafficFilters,
      mdsProgressionTemplates,
      mdsControlTowerExperience,
      mdsExperimentTemplates
    );
    progressionSelection.initialTrafficFilters = {
      trafficFilters: {}
    };
    progressionSelection.selectedTrafficFilters = {
      trafficFilters: {}
    };
    progressionSelection.stageTrafficFilterKeys = [];
    if (flightList && flightList.flights && flightList.flights.length === 1 && flightList.flights[0].type === FlightType.Treatment) {
      const expandedFlights = getExpandedFlightList(flightList);
      const treatmentFlight = flightList.flights[0];
      const controlFlight = _.first(
        _.filter(expandedFlights, (flight) => flight.name === treatmentFlight.name + getControlFlightSuffix())
      );
      if (controlFlight) {
        progressionSelection.selectedFlights = [treatmentFlight, controlFlight];
      } else {
        progressionSelection.selectedFlights = [treatmentFlight];
      }
    }
    const templateKeys = Object.keys(progressionSelection.progressionTemplateOptions);
    if (templateKeys.length === 1) {
      const selectTemplateId = templateKeys[0];
      progressionSelection = ProgressionSelectionUtilInstance.selectProgressionTemplate(progressionSelection, selectTemplateId);
    } else {
      let defaultTemplateId;
      _.each(progressionSelection.progressionTemplateOptions, function(template, k) {
        if (template.isDefaultSelection) {
          defaultTemplateId = k;
        }
      });
      if (!!defaultTemplateId) {
        progressionSelection = ProgressionSelectionUtilInstance.selectProgressionTemplate(
          progressionSelection,
          defaultTemplateId
        );
      }
    }
    return progressionSelection;
  }
  getProgressionSelectionForProgression(mdsTrafficFilters, mdsProgressionTemplate, mdsExperimentTemplates, mdsControlTowerExperience, progression) {
    if (!mdsProgressionTemplate) {
      return null;
    }
    let progressionSelection = getDefaultProgressionSelectionTemplates();
    const progressionTemplateId = progression.templateName;
    const progressionTemplate = this.getProgressionSelectionTemplate(
      mdsTrafficFilters,
      mdsProgressionTemplate,
      mdsControlTowerExperience,
      mdsExperimentTemplates
    );
    progressionSelection.progressionTemplateOptions = {
      [progressionTemplateId]: progressionTemplate
    };
    progressionSelection = ProgressionSelectionUtilInstance.selectProgressionTemplate(
      progressionSelection,
      progressionTemplateId
    );
    progressionSelection.selectedTrafficFilters = this.enrichTrafficFiltersWithTemplateData(
      progression.progressionFilters,
      progressionTemplate.initialTrafficFilters
    );
    progressionSelection.initialTrafficFilters = _.cloneDeep(progressionSelection.selectedTrafficFilters);
    progressionSelection.progressionName = progression.name;
    let treatmentFlight = ProgressionUtilsInstance.getFlightInProgression(progression, FlightType.Treatment);
    let controlFlight = ProgressionUtilsInstance.getFlightInProgression(progression, FlightType.CustomControl);
    progressionSelection.selectedFlights = _.filter([treatmentFlight, controlFlight], (flight) => flight !== null);
    progressionSelection.selectedFlights = ProgressionUtilsInstance.getFlightsInProgression(
      progression,
      FlightType.Treatment
    ).concat(ProgressionUtilsInstance.getFlightsInProgression(progression, FlightType.CustomControl));
    progressionSelection.progressionSettingsType = ProgressionUtilsInstance.getProgressionSettingsType(
      // @ts-ignore
      progression.progressionType
    );
    progressionSelection.trafficAllocation = progression.trafficAllocation;
    return progressionSelection;
  }
  /**
   * checkIsRequiredFromMds: Set trafficFilter isRequired property to true if set in the MDS config.
   * (Note: progressions currently ignore this value from MDS, but experiments do not)
   */
  getTrafficFiltersFromMDSFilters(mdsFilters, checkIsRequiredFromMds = false, requiredOnly = false) {
    let allFilters = {
      trafficFilters: {}
    };
    _.forOwn(mdsFilters, (mdsFilter, filterKey) => {
      const isRequired = checkIsRequiredFromMds ? mdsFilter.IsRequired : false;
      if (!requiredOnly || isRequired) {
        allFilters.trafficFilters[filterKey] = this.toTrafficFilter(filterKey, mdsFilters, isRequired, true);
      }
    });
    return allFilters;
  }
  addDefaultValuesFromMDSFilters(trafficFilters, mdsFilters) {
    _.forOwn(mdsFilters, (mdsFilter, filterKey) => {
      if (!!trafficFilters.trafficFilters[filterKey] && !!mdsFilter.DefaultValues && mdsFilter.DefaultValues.length > 0) {
        trafficFilters.trafficFilters[filterKey].currentValue = {
          clause: [
            {
              currentSelectedOperator: "In",
              selectedBaseOperators: ["In"],
              trafficFilterRule: {
                In: [...mdsFilter.DefaultValues]
              }
            }
          ]
        };
      }
    });
    return trafficFilters;
  }
  toTrafficFilter(trafficFilterKey, mdsTrafficFilters, isRequired = false, isEditable = true, allowNoFilter = false, initialValues = [], includeValuesForRemovedFilter = false) {
    let mdsFilter = this.getMdsFilter(mdsTrafficFilters, trafficFilterKey);
    if (!!mdsFilter) {
      return {
        displayName: mdsFilter.DisplayName,
        htmlDescription: mdsFilter.Description,
        isRequired,
        isEditable,
        allowNoFilter,
        operatorCategory: this.getOperatorCategory(mdsFilter.OperatorCategory),
        valueOption: {
          type: this.getDataType(mdsFilter.DataType),
          placeholder: "All Values",
          predefinedValues: this.getPredefinedValues(mdsFilter.Values)
        },
        currentValue: {
          clause: this.getTrafficFilterValues(initialValues)
        },
        displayOrder: mdsFilter.DisplayOrder,
        isHidden: mdsFilter.IsHidden || false,
        enabledOverrideTypes: mdsFilter.EnabledOverrideTypes || []
      };
    } else {
      return {
        displayName: trafficFilterKey + " (filter archived)",
        htmlDescription: `Traffic Key has been archived: ${trafficFilterKey}`,
        isRequired,
        isEditable,
        allowNoFilter,
        operatorCategory: OperatorCategory.InOnly,
        valueOption: {
          type: ValueType.predefined,
          placeholder: "All Values",
          predefinedValues: []
        },
        currentValue: {
          clause: includeValuesForRemovedFilter ? this.getTrafficFilterValues(initialValues) : []
        },
        displayOrder: 0,
        isHidden: false,
        enabledOverrideTypes: []
      };
    }
  }
  getMdsFilter(mdsTrafficFilters, trafficFilterKey) {
    let mdsKey = CommonUtilsInstance.getMatchingKeyIgnoreCase(mdsTrafficFilters, trafficFilterKey);
    if (!!mdsKey) {
      return mdsTrafficFilters[mdsKey];
    }
    return null;
  }
  normalizeProgressionTemplatesTrafficFilters(progressionTemplates, mdsTrafficFilters) {
    _.forOwn(progressionTemplates.ProgressionTemplates, (template, templateKey) => {
      if (!!template) {
        CommonUtilsInstance.correctCasingForKeys(template.TrialTrafficFilters, mdsTrafficFilters);
        _.forEach(template.Studies, (study) => {
          CommonUtilsInstance.correctCasingForKeys(study.StudyTrafficFilters, mdsTrafficFilters);
        });
        if (!!template.FreeFormTrafficFilters) {
          CommonUtilsInstance.correctCasingForKeys(template.FreeFormTrafficFilters, mdsTrafficFilters);
        }
      }
    });
    return progressionTemplates;
  }
  normalizeMdsFilterValues(mdsTrafficFilters) {
    _.forOwn(mdsTrafficFilters, (trafficFilter, key) => {
      trafficFilter.Values = toLowerCaseDictionary(trafficFilter.Values);
    });
    return mdsTrafficFilters;
  }
  parseSupportedProgressionSettingsTypes(mdsProgressionSettingsTypes, mdsControlTowerExperience) {
    let progressionSettingsTypes = [];
    if (!mdsProgressionSettingsTypes) {
      mdsProgressionSettingsTypes = [
        {
          Id: ProgressionSettingsType[ProgressionSettingsType.SingleTreatmentProgressionSettings]
        }
      ];
    }
    _.forEach(mdsProgressionSettingsTypes, (mdsProgressionSettingsType) => {
      let progressionSettingsType = this.parseSupportedProgressionSettingsType(
        mdsProgressionSettingsType,
        mdsControlTowerExperience
      );
      if (!!progressionSettingsType) {
        progressionSettingsTypes.push(progressionSettingsType);
      }
    });
    return progressionSettingsTypes;
  }
  parseSupportedProgressionSettingsType(mdsProgressionSettingsType, mdsControlTowerExperience) {
    var _a, _b;
    let progressionSettingsType = null;
    if (!mdsProgressionSettingsType) {
      return null;
    }
    const settingType = CommonUtilsInstance.getEnumIgnoreCase(
      ProgressionSettingsType,
      mdsProgressionSettingsType.Id,
      ProgressionSettingsType.SingleTreatmentProgressionSettings
    );
    const settingMetadata = ((_b = (_a = mdsControlTowerExperience == null ? void 0 : mdsControlTowerExperience.Progressions) == null ? void 0 : _a.ProgressionSettingsMetadata) == null ? void 0 : _b[ProgressionSettingsType[settingType]]) ? mdsControlTowerExperience.Progressions.ProgressionSettingsMetadata : getDefaultProgressionSettingsMetadata();
    const match = settingMetadata[ProgressionSettingsType[settingType]];
    progressionSettingsType = {
      id: settingType,
      displayName: (match == null ? void 0 : match.DisplayName) || ProgressionSettingsType[settingType],
      description: (match == null ? void 0 : match.Description) || ""
    };
    return progressionSettingsType;
  }
  getProgressionTemplatesOptions(trafficFilters, progressionTemplates, mdsControlTowerExperience, experimentTemplates) {
    let options = {};
    _.forOwn(progressionTemplates, (templateMetadata, templateKey) => {
      if (!!templateMetadata) {
        options[templateKey] = this.getProgressionSelectionTemplate(
          trafficFilters,
          templateMetadata,
          mdsControlTowerExperience,
          experimentTemplates
        );
      }
    });
    return options;
  }
  getProgressionSelectionTemplate(trafficFilters, templateMetadata, mdsControlTowerExperience, experimentTemplates) {
    return {
      id: templateMetadata.Id,
      progressionTemplateName: templateMetadata.Name,
      stages: this.getProgressionTargetInfo(templateMetadata, trafficFilters, experimentTemplates),
      stageTrafficFilterKeys: this.getProgressionStageTrafficFilters(templateMetadata),
      initialTrafficFilters: this.getTrafficFilters(trafficFilters, templateMetadata.TrialTrafficFilters),
      // @ts-ignore
      initialFreeFormTrafficFilters: !!templateMetadata.FreeFormTrafficFilters ? this.getTrafficFilters(trafficFilters, templateMetadata.FreeFormTrafficFilters) : null,
      defaultProgressionName: templateMetadata.DefaultProgressionName,
      // @ts-ignore
      allowAdditionalFilters: templateMetadata.AllowAdditionalTrafficFilters !== null ? templateMetadata.AllowAdditionalTrafficFilters : true,
      isDefaultSelection: !!templateMetadata.IsDefaultSelection,
      supportedProgressionSettingsTypes: this.parseSupportedProgressionSettingsTypes(
        // @ts-ignore
        templateMetadata.SupportedProgressionSettingsTypes,
        mdsControlTowerExperience
      ),
      isHidden: templateMetadata.IsHidden || false
    };
  }
  getProgressionTargetInfo(templateMetadata, trafficFilters, experimentTemplates) {
    const progressionTargetInfos = _.map(templateMetadata.Studies, (study) => {
      return {
        name: study.Name,
        trafficAssignmentSequence: _.cloneDeep(study.TrafficAssignmentSequence),
        // @ts-ignore
        targetTrafficFilters: this.getTrafficFilters(trafficFilters, study.StudyTrafficFilters),
        experimentTemplateId: study.ExperimentTemplate,
        experimentTemplate: this.getExperimentTemplate(study.ExperimentTemplate, experimentTemplates)
      };
    });
    return progressionTargetInfos;
  }
  getExperimentTemplate(experimentTemplateId, mdsExperimentTemplates) {
    const template = CommonUtilsInstance.getMatchingValueIgnoreCase(mdsExperimentTemplates, experimentTemplateId);
    if (template) {
      return {
        name: template.Name,
        workflow: _.map(template.Workflow, (stage) => {
          return {
            duration: stage.Duration,
            steps: _.map(stage.Steps, (step) => {
              return { type: step.Type };
            })
          };
        })
      };
    }
  }
  getProgressionStageTrafficFilters(templateMetadata) {
    return Array.from(new Set(_.flatMap(templateMetadata.Studies, (s) => _.map(Object.keys(s.StudyTrafficFilters), (tf) => tf))));
  }
  getTrafficFilters(trafficFilters, templateTrafficFilters) {
    if (!EnvironmentService.enableRequiredMDSFiltersValidation()) {
      return this.getTrafficFiltersOld(trafficFilters, templateTrafficFilters);
    }
    trafficFilters = trafficFilters || {};
    templateTrafficFilters = templateTrafficFilters || {};
    return {
      trafficFilters: __spreadValues(__spreadValues({}, Object.keys(trafficFilters).reduce((acc, key) => {
        const val = trafficFilters[key];
        if (val.IsRequired) {
          return __spreadProps(__spreadValues({}, acc), {
            [key]: this.toTrafficFilter(key, trafficFilters, !!val.IsRequired, true, !!val.AllowNoFilter)
          });
        } else {
          return acc;
        }
      }, {})), Object.keys(templateTrafficFilters).reduce((acc, key) => {
        const val = templateTrafficFilters[key];
        if (!!val) {
          return __spreadProps(__spreadValues({}, acc), {
            [key]: this.toTrafficFilter(
              key,
              trafficFilters,
              val.IsRequired || false,
              val.IsEditable || false,
              val.AllowNoFilter || false,
              val.Values
            )
          });
        } else {
          return acc;
        }
      }, {}))
    };
  }
  /**
   * @obsolete We should remove this when the flag above is removed after experiment is finished.
   */
  getTrafficFiltersOld(trafficFilters, templateTrafficFilters) {
    let internalTrafficFilters = {
      trafficFilters: {}
    };
    _.forOwn(templateTrafficFilters, (templateTrafficFilterData, trafficFilterKey) => {
      if (!!trafficFilters[trafficFilterKey]) {
        internalTrafficFilters.trafficFilters[trafficFilterKey] = this.toTrafficFilter(
          trafficFilterKey,
          trafficFilters,
          templateTrafficFilterData.IsRequired || false,
          templateTrafficFilterData.IsEditable || false,
          templateTrafficFilterData.AllowNoFilter || false,
          templateTrafficFilterData.Values
        );
      }
    });
    return internalTrafficFilters;
  }
  enrichTrafficFiltersWithTemplateData(trafficFilters, templateFilters) {
    let enrichedFilters = {
      trafficFilters: {}
    };
    _.forOwn(trafficFilters.trafficFilters, (filter, key) => {
      let templateFilter = templateFilters.trafficFilters[key];
      let enrichedFilter = _.cloneDeep(filter);
      if (templateFilter) {
        enrichedFilter.isEditable = templateFilter.isEditable;
        enrichedFilter.isRequired = templateFilter.isRequired;
        enrichedFilter.allowNoFilter = templateFilter.allowNoFilter;
      }
      enrichedFilters.trafficFilters[key] = enrichedFilter;
    });
    return enrichedFilters;
  }
  getOperatorCategory(tfOperatorCategory) {
    if (!tfOperatorCategory) {
      return OperatorCategory.InOnly;
    }
    if (tfOperatorCategory === 1 || tfOperatorCategory.toString().toLowerCase() === "inonly") {
      return OperatorCategory.InOnly;
    } else if (tfOperatorCategory === 2 || tfOperatorCategory.toString().toLowerCase() === "inandnotin") {
      return OperatorCategory.InAndNotIn;
    } else if (tfOperatorCategory === 3 || tfOperatorCategory.toString().toLowerCase() === "alloperators") {
      return OperatorCategory.AllOperators;
    } else {
      return OperatorCategory.InOnly;
    }
  }
  getDataType(dataType) {
    if ((dataType == null ? void 0 : dataType.toLowerCase()) === "integer") {
      return ValueType.integer;
    }
    if (!dataType || dataType.toLowerCase() !== "version") {
      return ValueType.predefined;
    } else {
      return ValueType.version;
    }
  }
  getPredefinedValues(values) {
    if (!values)
      return [];
    let predefinedValues = [];
    _.forOwn(values, (displayValue, valuekey) => {
      predefinedValues.push({
        name: valuekey.toLowerCase(),
        displayName: displayValue
      });
    });
    return predefinedValues;
  }
  getTrafficFilterValues(values) {
    if (!values || values.length === 0) {
      return [
        {
          trafficFilterRule: {
            [OperatorConstants.In]: []
          },
          currentSelectedOperator: OperatorConstants.In,
          selectedBaseOperators: [OperatorConstants.In]
        }
      ];
    }
    let clause = [];
    _.each(values, (rule) => {
      let allKeys = _.filter(Object.keys(rule), (operator) => OperatorConstants.isValidOperator(operator) && !!rule[operator]);
      allKeys.sort((a, b) => OperatorConstants.compare(a, b));
      if (allKeys.length > 0) {
        let ruleSet = {
          trafficFilterRule: _.reduce(
            allKeys,
            (res, key) => {
              res[key] = toLowerCaseArray(removeEmptyValues(rule[key]));
              return res;
            },
            {}
          ),
          currentSelectedOperator: CustomOperatorConstants.getCustomOperatorFromOperatorArray(allKeys),
          selectedBaseOperators: allKeys
        };
        if (!!ruleSet.currentSelectedOperator) {
          clause.push(ruleSet);
        }
      }
    });
    return clause;
  }
}
const MasterDataUtilInstance = new MasterDataUtils();
var ProgressionDialogType = /* @__PURE__ */ ((ProgressionDialogType2) => {
  ProgressionDialogType2[ProgressionDialogType2["create"] = 0] = "create";
  ProgressionDialogType2[ProgressionDialogType2["read"] = 1] = "read";
  ProgressionDialogType2[ProgressionDialogType2["iterate"] = 2] = "iterate";
  ProgressionDialogType2[ProgressionDialogType2["promoteFlight"] = 3] = "promoteFlight";
  ProgressionDialogType2[ProgressionDialogType2["bulkEditStages"] = 4] = "bulkEditStages";
  ProgressionDialogType2[ProgressionDialogType2["bulkEditConfirm"] = 5] = "bulkEditConfirm";
  ProgressionDialogType2[ProgressionDialogType2["readAndEdit"] = 6] = "readAndEdit";
  ProgressionDialogType2[ProgressionDialogType2["editConfirm"] = 7] = "editConfirm";
  return ProgressionDialogType2;
})(ProgressionDialogType || {});
class ProgressionValidation {
  constructor() {
    __publicField(this, "stringValueMaxLength", 500);
    __publicField(this, "versionTypeRegex", /^\d+(\.\d+){1,3}$/);
    __publicField(this, "vNextVersionTypeRegex", /^\d+(\.\d+){2,3}$/);
    __publicField(this, "vNextIntegerTypeRegex", /^[-]?\d+$/);
    __publicField(this, "audienceFilterValueRegex", /^[A-Za-z0-9]([-_.]?[A-Za-z0-9]+)*$/);
    __publicField(this, "abAfterSeedfinderMessage", "Seedfinder optimizes traffic to improve scorecard sensitivity. This Seedfinder stage requires at least one traffic step that will generate a scorecard.");
    __publicField(this, "isValidVNextVersionValue", (value) => {
      return this.vNextVersionTypeRegex.test(value);
    });
    __publicField(this, "isValidVNextIntegerValue", (value) => {
      return this.vNextIntegerTypeRegex.test(value);
    });
  }
  // @ts-ignore
  validateProgressionName(progressionName) {
    if (!progressionName) {
      return {
        message: "Please provide a progression name.",
        link: "",
        linkMessage: ""
      };
    }
    if (progressionName.length > this.stringValueMaxLength) {
      return {
        message: `Progression name must be less than ${this.stringValueMaxLength} characters long.`,
        link: "",
        linkMessage: ""
      };
    }
  }
  validateProgressionTrafficAllocation(isAutoGeneratedIsolationGroup, trafficAllocation, dialogType, progression) {
    if (!isAutoGeneratedIsolationGroup) {
      if (!trafficAllocation && trafficAllocation !== 0) {
        return {
          message: "Specified traffic % is required for progression running on an existing isolation group",
          link: "",
          linkMessage: ""
        };
      } else if (ProgressionUtilsInstance.isInvalidTraffic(trafficAllocation)) {
        return {
          message: "Traffic allocation % must be between 0.1% and 100%",
          link: "",
          linkMessage: ""
        };
      } else if (dialogType === 2 && !!progression && // @ts-ignore
      trafficAllocation < progression.trafficAllocation) {
        return {
          message: `Cannot decrease traffic allocation % while iterating. Traffic % must be at least ${progression.trafficAllocation}%`,
          link: "",
          linkMessage: ""
        };
      }
    }
    return null;
  }
  // @ts-ignore
  validateSelectedProgressionTemplate(selectedProgressionName) {
    if (!selectedProgressionName) {
      return {
        message: "Please select a progression template.",
        link: "",
        linkMessage: ""
      };
    }
  }
  validateSelectedFlightName(progressionSelection, dialogType) {
    if (ProgressionSelectionUtilInstance.supportsMultipleFlights(progressionSelection)) {
      if (dialogType === 3) {
        if (progressionSelection.selectedFlights.filter((f) => f.type === FlightType.Treatment).length !== 1 || progressionSelection.selectedFlights.filter((f) => f.type === FlightType.CustomControl).length > 1) {
          return {
            message: "Please select one treatment flight and zero or one control flight",
            link: "",
            linkMessage: ""
          };
        }
      } else if (dialogType === 0 || dialogType === 2) {
        if (progressionSelection.selectedFlights.filter((f) => f.type === FlightType.Treatment).length === 0 || progressionSelection.selectedFlights.filter((f) => f.type === FlightType.CustomControl).length === 0) {
          return {
            message: "Please select at least one treatment and one control flight",
            link: "",
            linkMessage: ""
          };
        }
      }
    } else {
      if (progressionSelection.selectedFlights.filter((f) => f.type === FlightType.Treatment).length === 0 || progressionSelection.selectedFlights.filter((f) => f.type === FlightType.CustomControl).length === 0) {
        return {
          message: "Please select at least one treatment and one control flight",
          link: "",
          linkMessage: ""
        };
      }
    }
  }
  validateTrafficFilters(trafficFilters, inReadOnlyMode = false, isTeamStage = false, allTrafficFilters = null) {
    let errors = [];
    if (!!trafficFilters) {
      _.forOwn(trafficFilters.trafficFilters, (filter, key) => {
        let tfError = this.validateTrafficFilter(filter, inReadOnlyMode);
        if (tfError) {
          errors.push(tfError);
        }
      });
      if (!!isTeamStage) {
        let tfError = this.validateTrafficFilterForTeamStage(trafficFilters.trafficFilters, allTrafficFilters);
        if (tfError) {
          errors.push(tfError);
        }
      }
    }
    if (EnvironmentService.isUnifiedView && !!allTrafficFilters) {
      Object.keys(allTrafficFilters.trafficFilters).forEach((key) => {
        const filter = allTrafficFilters.trafficFilters[key];
        if (filter.isRequired) {
          let tfError = this.validateTrafficFilter(trafficFilters.trafficFilters[key] || filter, inReadOnlyMode);
          if (tfError) {
            errors.push(tfError);
          }
        }
      });
    }
    return _.uniqBy(errors, "message");
  }
  validateTrafficFilterForTeamStage(trafficFilters, allTrafficFilters) {
    let message = "";
    const filteredTeamStageKeys = Object.keys(trafficFilters).filter(
      (key) => !!trafficFilters[key].enabledOverrideTypes && // @ts-ignore
      containsIgnoreCase(trafficFilters[key].enabledOverrideTypes, OverrideType.ForcedInclude) && TrafficFilterUtilInstance.hasValues(trafficFilters[key])
    );
    if (filteredTeamStageKeys.length === 0) {
      let enableListKeys = allTrafficFilters ? Object.keys(allTrafficFilters.trafficFilters).filter(
        (key) => !!allTrafficFilters.trafficFilters[key].enabledOverrideTypes && // @ts-ignore
        containsIgnoreCase(allTrafficFilters.trafficFilters[key].enabledOverrideTypes, OverrideType.ForcedInclude)
      ) : [];
      const enabledOverrideFilters = enableListKeys.length > 0 ? `(${enableListKeys.map((key) => allTrafficFilters.trafficFilters[key].displayName).join(",")})` : "";
      message = `Team-targeting stages require at least one team-based filter. Please use at least one of these team-based filters on this stage: ${enabledOverrideFilters}`;
    } else {
      const notInKeys = filteredTeamStageKeys.filter(
        (key) => !compareIgnoreCase(
          TrafficFilterUtilInstance.getCurrentOperator(0, trafficFilters[key].currentValue),
          OperatorConstants.In
        )
      );
      if (notInKeys.length > 0) {
        const filteredTeamStageFilters = filteredTeamStageKeys.map((key) => trafficFilters[key].displayName).join(",");
        message = `Team-targeting filters must use the 'In' operator to avoid overexposure. Please update the operator on (${filteredTeamStageFilters})`;
      } else {
        return null;
      }
    }
    return {
      message,
      link: "",
      linkMessage: ""
    };
  }
  validateTrafficFilter(trafficFilter, inReadOnlyMode = false, maxLength = 256) {
    var _a, _b, _c, _d, _e, _f, _g;
    if ((_a = trafficFilter == null ? void 0 : trafficFilter.isHidden) != null ? _a : false) {
      return null;
    }
    if (((_b = trafficFilter == null ? void 0 : trafficFilter.isRequired) != null ? _b : false) && !inReadOnlyMode && !TrafficFilterUtilInstance.hasValues(trafficFilter)) {
      return {
        message: `${trafficFilter.displayName} filter is required.`,
        link: "",
        linkMessage: ""
      };
    }
    if (((_d = (_c = trafficFilter == null ? void 0 : trafficFilter.valueOption) == null ? void 0 : _c.type) != null ? _d : ValueType.predefined) === ValueType.version && (trafficFilter.isRequired || TrafficFilterUtilInstance.hasValues(trafficFilter))) {
      if (_.some(
        trafficFilter.currentValue.clause,
        (filterRuleDictionary) => _.some(
          filterRuleDictionary.trafficFilterRule,
          (values) => _.some(values, (value) => !this.versionTypeRegex.test(value))
        )
      )) {
        return {
          message: `Invalid format for ${trafficFilter.displayName}. Must be of the form x.x, x.x.x or x.x.x.x, where x are numbers.`,
          link: "",
          linkMessage: ""
        };
      }
      const orError = this.validateOrValues(trafficFilter);
      const betweenError = this.validateBetweenValues(trafficFilter);
      let errorMsg = "";
      if (!!orError) {
        errorMsg = errorMsg.concat(orError.message);
      }
      if (!!betweenError) {
        errorMsg = errorMsg.concat(betweenError.message);
      }
      return errorMsg.length === 0 ? null : {
        message: errorMsg,
        link: "",
        linkMessage: ""
      };
    }
    if (((_f = (_e = trafficFilter == null ? void 0 : trafficFilter.valueOption) == null ? void 0 : _e.type) != null ? _f : ValueType.predefined) === ValueType.integer && (((_g = trafficFilter == null ? void 0 : trafficFilter.isRequired) != null ? _g : false) || TrafficFilterUtilInstance.hasValues(trafficFilter))) {
      if (_.some(
        trafficFilter.currentValue.clause,
        (filterRuleDictionary) => _.some(
          filterRuleDictionary.trafficFilterRule,
          (values) => _.some(values, (value) => !this.isValidVNextIntegerValue(value))
        )
      )) {
        return {
          message: inputInvalidIntegerMessage,
          link: "",
          linkMessage: ""
        };
      }
    }
    return null;
  }
  /**
   * Check if the progression selection is valid
   * @param progressionSelection
   */
  validateProgression(progressionSelection, dialogType, isAutoGeneratedIsolationGroup, progression) {
    let errors = [];
    let progressionTemplateError = this.validateSelectedProgressionTemplate(progressionSelection.selectedProgressionTemplateName);
    if (progressionTemplateError) {
      errors.push(progressionTemplateError);
    }
    let flightNameError = this.validateSelectedFlightName(progressionSelection, dialogType);
    if (flightNameError) {
      errors.push(flightNameError);
    }
    let progressionNameError = this.validateProgressionName(progressionSelection.progressionName);
    if (progressionNameError) {
      errors.push(progressionNameError);
    }
    errors = errors.concat(this.validateTrafficFilters(progressionSelection.selectedTrafficFilters, false));
    let trafficAllocationError = this.validateProgressionTrafficAllocation(
      isAutoGeneratedIsolationGroup,
      progressionSelection.trafficAllocation,
      dialogType,
      progression
    );
    if (trafficAllocationError) {
      errors.push(trafficAllocationError);
    }
    return errors;
  }
  validateProgressionStage(progressionStageName, trafficSteps, selectedTrafficFilters, isUsingAutoGeneratedIsolationGroup, progressionTrafficAllocation, inReadOnlyMode = false, isTeamStage = false, allTrafficFilters = null) {
    let errors = [];
    if (!progressionStageName) {
      errors.push("A name for the progression stage is required.");
    }
    if (trafficSteps == null || trafficSteps.length == 0) {
      errors.push("Please add at least one stage for the progression stage");
    }
    const filteredTrafficSteps = trafficSteps.filter((s) => !ProgressionUtilsInstance.hasSeedFinderStep(s.stepTypes));
    let trafficPercentages = _.map(filteredTrafficSteps, (s) => s.trafficPercentage);
    if (_.filter(trafficPercentages, (t) => t === null || t === void 0).length > 0) {
      errors.push("Traffic percentage can't be empty");
    } else if (ProgressionUtilsInstance.isInvalidTrafficPercent(filteredTrafficSteps)) {
      errors.push(`Traffic sum percentage for treatment flight(s) is invalid (Allowed Range is 0.1 ≤ x ≤ 100)`);
    }
    if (!isUsingAutoGeneratedIsolationGroup && _.filter(trafficPercentages, (t) => t > progressionTrafficAllocation).length > 0) {
      errors.push(
        `Traffic steps cannot be greater than the specified traffic percentage of ${progressionTrafficAllocation}% for the progression`
      );
    }
    let filterValidationErrors = this.validateTrafficFilters(
      selectedTrafficFilters,
      inReadOnlyMode,
      isTeamStage,
      allTrafficFilters
    );
    errors = errors.concat(_.map(filterValidationErrors, (v) => v.message));
    return errors;
  }
  // Validation for newly added traffic steps to existing stage
  validateAddedTrafficSteps(trafficSteps, lastRunningTrafficValue) {
    let errors = [];
    const filteredTrafficSteps = trafficSteps.filter((s) => !ProgressionUtilsInstance.hasSeedFinderStep(s.stepTypes));
    const trafficPercentages = filteredTrafficSteps.filter((ts) => ts.isEnabled && ts.state === ExperimentStates.NEW).map((ts) => ts.trafficPercentage);
    if (!!lastRunningTrafficValue) {
      const minPendingTraffic = _.min(trafficPercentages);
      if (minPendingTraffic <= lastRunningTrafficValue) {
        errors.push(
          "Invalid traffic. Traffic percentage should be greater than the current running traffic: " + lastRunningTrafficValue
        );
      }
    }
    return errors;
  }
  // Validation for iterated traffic steps to existing stage
  validateIteratedTrafficSteps(trafficSteps, lastRunningTrafficValue) {
    let errors = [];
    const filteredTrafficSteps = trafficSteps.filter((s) => !ProgressionUtilsInstance.hasSeedFinderStep(s.stepTypes));
    const trafficPercentages = filteredTrafficSteps.map((ts) => ts.trafficPercentage);
    if (!!lastRunningTrafficValue) {
      const minPendingTraffic = _.min(trafficPercentages);
      if (minPendingTraffic > lastRunningTrafficValue) {
        errors.push(
          "Invalid traffic. Minimum trafffic percentage " + minPendingTraffic + " in iteration should be smaller than the current running traffic: " + lastRunningTrafficValue + '. During iteration, the last running step cannot be increased. To add a larger step, please add a new traffic step to the existing stage and use "Advance", or stop the stage to edit the current traffic step.'
        );
      }
    }
    return errors;
  }
  // Validation for stage updates with only deletes
  validateIsOnlyDeletingCompletedStages(initialTrafficSteps, desiredTrafficSteps) {
    let errors = [];
    if (initialTrafficSteps.some(
      (initialStep) => !ExperimentStepStates.isNew(initialStep.state) && !desiredTrafficSteps.find((step) => step.trafficPercentage == initialStep.trafficPercentage)
    )) {
      errors.push("Cannot delete completed steps. Please provide a different traffic sequence");
    }
    return errors;
  }
  progressionCreateDisableReasons(userHasWritePermission, rootFeatureOperationCheck, progressionCloneGroups, customAnalysisRequiredInFeature, customAnalysisDefined) {
    if (!userHasWritePermission) {
      return [PermissionMessages.noWritePermissionError];
    }
    if (this.checkForMultipleProgressionDisable(progressionCloneGroups)) {
      return ["Multiple progressions are not allowed for this type of feature"];
    }
    if (!rootFeatureOperationCheck) {
      return [];
    }
    let isFeatureUpdateIsDisabled = OperationCheckUtils.isOperationDisabled(
      rootFeatureOperationCheck,
      OperationCheckTypes.Update
    );
    let gateMessages = OperationCheckUtils.getGateMessages(rootFeatureOperationCheck, OperationCheckTypes.Update);
    let isMessageContainPermission = _.some(gateMessages, (gateMessage) => {
      return gateMessage.indexOf("permissions") >= 0;
    });
    if (isFeatureUpdateIsDisabled && isMessageContainPermission)
      return gateMessages;
    if (customAnalysisRequiredInFeature && !customAnalysisDefined)
      return ["Add additional analysis to proceed"];
    return [];
  }
  validateIfAbStepAfterSeedfinder(latestTrafficSteps, trafficDistributionType) {
    if (!latestTrafficSteps) {
      return [];
    }
    const hasSeedFinderStep = latestTrafficSteps.filter((step) => ProgressionUtilsInstance.hasSeedFinderStep(step.stepTypes));
    if (hasSeedFinderStep && hasSeedFinderStep.length > 0) {
      const sortedTrafficStages = latestTrafficSteps.filter((step) => !ProgressionUtilsInstance.hasSeedFinderStep(step.stepTypes)).sort((a, b) => a.trafficPercentage - b.trafficPercentage);
      if (!sortedTrafficStages || sortedTrafficStages.length === 0) {
        return [this.abAfterSeedfinderMessage];
      }
      if (sortedTrafficStages[0] && sortedTrafficStages[0].trafficPercentage > 50 && trafficDistributionType === TrafficDistributionType.SingleTreatmentMirrorControl) {
        return [this.abAfterSeedfinderMessage];
      }
    }
    return [];
  }
  vNextAudienceFilterInlineValidation(trafficFilter, maxLength = 256) {
    var _a, _b;
    const { isRequired, currentValue, valueOption, displayName } = trafficFilter;
    const { clause = [] } = currentValue;
    let result = clause.map((c) => void 0);
    const hasValues = TrafficFilterUtilInstance.hasValues(trafficFilter);
    if (isRequired && !hasValues) {
      result = this.mergeStringArrays(
        clause.map((c) => "Required"),
        // @ts-ignore
        result
      );
    }
    const doesnotHaveValuesInRule = _.map(clause, (c) => !TrafficFilterUtilInstance.hasValuesInRule(c));
    if (clause.length > 1 && _.some(doesnotHaveValuesInRule, (r) => r)) {
      result = this.mergeStringArrays(this.invalidClauseValues(doesnotHaveValuesInRule, "Required"), result);
    }
    if (hasValues) {
      const incorrectFilterValuesInRule = _.map(
        clause,
        (c) => _.some(c.trafficFilterRule, (values) => _.some(values, (value) => !this.audienceFilterValueRegex.test(value)))
      );
      if (_.some(incorrectFilterValuesInRule, (r) => r)) {
        result = this.mergeStringArrays(
          // @ts-ignore
          this.invalidClauseValues(incorrectFilterValuesInRule, inputInvalidStringValueMessage),
          result
        );
      }
      const hasLongValues = _.map(
        clause,
        (c) => _.some(c.trafficFilterRule, (values) => _.some(values, (value) => value.length > maxLength))
      );
      if (_.some(hasLongValues, (r) => r)) {
        result = this.mergeStringArrays(
          // @ts-ignore
          this.invalidClauseValues(hasLongValues, inputInvalidLongStringValueMessage(maxLength)),
          result
        );
      }
    }
    if (((_a = valueOption == null ? void 0 : valueOption.type) != null ? _a : ValueType.predefined) === ValueType.version && (trafficFilter.isRequired || hasValues)) {
      const versionInvalids = _.map(
        clause,
        (c) => _.some(c.trafficFilterRule, (values) => _.some(values, (value) => !this.isValidVNextVersionValue(value)))
      );
      if (_.some(versionInvalids, (v) => v)) {
        result = this.mergeStringArrays(
          // @ts-ignore
          this.invalidClauseValues(versionInvalids, inputInvalidVersionValueMessage(displayName)),
          result
        );
      }
    }
    if (((_b = valueOption == null ? void 0 : valueOption.type) != null ? _b : ValueType.predefined) === ValueType.integer && (isRequired || hasValues)) {
      const invalidIntegers = _.map(
        clause,
        (filterRuleDictionary) => _.some(
          filterRuleDictionary.trafficFilterRule,
          (values) => _.some(values, (value) => !this.isValidVNextIntegerValue(value))
        )
      );
      if (_.some(invalidIntegers, (i) => i)) {
        result = this.mergeStringArrays(this.invalidClauseValues(invalidIntegers, inputInvalidIntegerMessage), result);
      }
    }
    const invalidRanges = _.map(
      clause,
      (filterRuleDictionary) => _.some(
        filterRuleDictionary.selectedBaseOperators,
        (operator) => isRangeOperator(operator) && !!filterRuleDictionary.trafficFilterRule[operator] && filterRuleDictionary.trafficFilterRule[operator].length > 1
      )
    );
    if (_.some(invalidRanges, (r) => r)) {
      result = this.mergeStringArrays(this.invalidClauseValues(invalidRanges, inputInvalidRangeMultipleValueMessage), result);
    }
    if (_.some(clause, (c) => !!this.betweenValueValidation(trafficFilter, c))) {
      result = this.mergeStringArrays(
        clause.map((c) => this.betweenValueValidation(trafficFilter, c)),
        // @ts-ignore
        result
      );
    }
    return _.some(result, (r) => !!r) ? result : void 0;
  }
  /**
   * Merge 2 string array based on OR logic.
   * arr1: [1, undefined, 3, 4, undefined] arr2: [undefined, 2, 3, 5, undefined]
   * result: [1, 2, 3, 4, undefined]
   * NOTE: if element is not present in both the array, undefined will be used at that place
   * NOTE: if element is present in arr1 and arr2, arr1 value is used in result
   * @param arr1
   * @param arr2
   */
  mergeStringArrays(arr1, arr2) {
    return _.zipWith(arr1, arr2, (a, b) => a || b || void 0);
  }
  invalidClauseValues(incorrectFilterValuesInRule, message) {
    return incorrectFilterValuesInRule.map((r) => r ? message : void 0);
  }
  checkForMultipleProgressionDisable(progressionCloneGroups) {
    if (!progressionCloneGroups) {
      return false;
    }
    const keys = Object.keys(progressionCloneGroups);
    return keys.length > 0 && this.isMultipleProgressionDisabled(progressionCloneGroups);
  }
  isMultipleProgressionDisabled(progressionCloneGroups) {
    let keys = Object.keys(progressionCloneGroups);
    let isMultipleProgressionDisabled = false;
    _.forEach(keys, (key) => {
      if (_.some(
        progressionCloneGroups[key],
        (progression) => progression.progressionType === ProgressionType.OverrideSetProgression
      )) {
        isMultipleProgressionDisabled = true;
      }
    });
    return isMultipleProgressionDisabled;
  }
  validateBetweenValues(trafficFilter) {
    let error = null;
    let between = trafficFilter.currentValue.clause.filter((c) => c.currentSelectedOperator === CustomOperatorConstants.Between);
    between.forEach((filterRuleDictionary) => {
      const validationError = this.betweenValueValidation(trafficFilter, filterRuleDictionary);
      if (!!validationError) {
        error = {
          message: validationError,
          link: "",
          linkMessage: ""
        };
      }
    });
    return error;
  }
  betweenValueValidation(trafficFilter, filterRuleDictionary) {
    var _a, _b;
    let error = void 0;
    const { valueOption, displayName } = trafficFilter;
    if (filterRuleDictionary.currentSelectedOperator !== CustomOperatorConstants.Between) {
      return error;
    }
    let lt = !!filterRuleDictionary.trafficFilterRule[OperatorConstants.LessThan] ? filterRuleDictionary.trafficFilterRule[OperatorConstants.LessThan] : filterRuleDictionary.trafficFilterRule[OperatorConstants.LessThanOrEqual];
    let gt = !!filterRuleDictionary.trafficFilterRule[OperatorConstants.GreaterThan] ? filterRuleDictionary.trafficFilterRule[OperatorConstants.GreaterThan] : filterRuleDictionary.trafficFilterRule[OperatorConstants.GreaterThanOrEqual];
    if (!lt || lt.length === 0 || !gt || gt.length === 0) {
      error = inputInvalidRangeMissingValueMessage(displayName);
    } else {
      if (((_a = valueOption == null ? void 0 : valueOption.type) != null ? _a : ValueType.predefined) === ValueType.integer) {
        if (parseInt(gt[0]) > parseInt(lt[0])) {
          error = inputInvalidBetweenRangeValueMessage(displayName);
        }
      } else if (((_b = valueOption == null ? void 0 : valueOption.type) != null ? _b : ValueType.predefined) === ValueType.version) {
        if (!this.versionIsLessThan(gt[0], lt[0])) {
          error = inputInvalidBetweenRangeValueMessage(displayName);
        }
      }
    }
    return error;
  }
  validateOrValues(trafficFilter) {
    let error = null;
    let or = trafficFilter.currentValue.clause.filter((c) => isRangeOperator(c.currentSelectedOperator));
    const validationError = this.orValueValidation(trafficFilter, or);
    if (!!validationError) {
      error = {
        message: validationError,
        link: "",
        linkMessage: ""
      };
    }
    return error;
  }
  orValueValidation(trafficFilter, filterRuleDictionaries) {
    var _a, _b, _c, _d;
    let error = void 0;
    const { valueOption, displayName } = trafficFilter;
    let ltFilters = (_a = filterRuleDictionaries.filter(
      (r) => r.currentSelectedOperator === OperatorConstants.LessThanOrEqual || r.currentSelectedOperator === OperatorConstants.LessThan
    )) == null ? void 0 : _a.map(
      (lt) => !!lt.trafficFilterRule[OperatorConstants.LessThan] ? lt.trafficFilterRule[OperatorConstants.LessThan][0] : lt.trafficFilterRule[OperatorConstants.LessThanOrEqual][0]
    );
    let gtFilters = (_b = filterRuleDictionaries.filter(
      (r) => r.currentSelectedOperator === OperatorConstants.GreaterThanOrEqual || r.currentSelectedOperator === OperatorConstants.GreaterThan
    )) == null ? void 0 : _b.map(
      (lt) => !!lt.trafficFilterRule[OperatorConstants.GreaterThan] ? lt.trafficFilterRule[OperatorConstants.GreaterThan][0] : lt.trafficFilterRule[OperatorConstants.GreaterThanOrEqual][0]
    );
    if (!ltFilters || ltFilters.length === 0 || !gtFilters || gtFilters.length === 0) {
      return error;
    }
    let upperBound;
    let lowerBound;
    if (((_c = valueOption == null ? void 0 : valueOption.type) != null ? _c : ValueType.predefined) === ValueType.integer) {
      upperBound = ltFilters.sort((lt1, lt2) => parseInt(lt2) - parseInt(lt1))[0];
      lowerBound = gtFilters.sort((gt1, gt2) => parseInt(gt1) - parseInt(gt2))[0];
      if (parseInt(upperBound) >= parseInt(lowerBound)) {
        error = inputInvalidOrRangeValueMessage(displayName);
      }
    } else if (((_d = valueOption == null ? void 0 : valueOption.type) != null ? _d : ValueType.predefined) === ValueType.version) {
      upperBound = ltFilters.sort((lt1, lt2) => this.versionIsLessThan(lt2, lt1) ? -1 : 1)[0];
      lowerBound = gtFilters.sort((gt1, gt2) => this.versionIsLessThan(gt1, gt2) ? -1 : 1)[0];
      if (this.versionIsLessThan(lowerBound, upperBound)) {
        error = inputInvalidOrRangeValueMessage(displayName);
      }
    }
    return error;
  }
  versionIsLessThan(left, right) {
    if (!this.versionTypeRegex.test(right) || !this.versionTypeRegex.test(left)) {
      return false;
    }
    let rightNums = right.split(".");
    let leftNums = left.split(".");
    for (let i = 0; i < Math.max(leftNums.length, rightNums.length); ++i) {
      let leftDigit = 0;
      if (i < leftNums.length) {
        leftDigit = parseInt(leftNums[i]);
      }
      let rightDigit = 0;
      if (i < rightNums.length) {
        rightDigit = parseInt(rightNums[i]);
      }
      if (leftDigit <= rightDigit) {
        if (leftDigit < rightDigit) {
          return true;
        }
        continue;
      }
      if (rightDigit < leftDigit) {
        return false;
      }
    }
    return false;
  }
}
const progressionValidationInstance = new ProgressionValidation();
class TrafficFilterUtils {
  hasValues(trafficFilter) {
    var _a;
    if (!!trafficFilter && !!trafficFilter.currentValue && !!trafficFilter.currentValue.clause) {
      if (((_a = trafficFilter.valueOption) == null ? void 0 : _a.placeholder) === "All Values" && !!trafficFilter.allowNoFilter) {
        return true;
      }
      return _.some(trafficFilter.currentValue.clause, (c) => this.hasValuesInRule(c));
    }
    return false;
  }
  hasValuesInRule(ruleDictionary) {
    return !!ruleDictionary && !!ruleDictionary.selectedBaseOperators && ruleDictionary.selectedBaseOperators.length > 0 && _.every(ruleDictionary.selectedBaseOperators, (operator) => {
      let ruleSet = ruleDictionary.trafficFilterRule[operator];
      if (!!ruleSet && ruleSet.filter((r) => !!r).length > 0) {
        return true;
      } else {
        return false;
      }
    });
  }
  toTrafficFiltersArray(trafficFilterDictionary) {
    if (!trafficFilterDictionary) {
      trafficFilterDictionary = {
        trafficFilters: {}
      };
    }
    let trafficFiltersInternal = [];
    _.forOwn(trafficFilterDictionary.trafficFilters, (trafficFilterValue, trafficFilterKey) => {
      trafficFiltersInternal.push({ key: trafficFilterKey, trafficFilter: trafficFilterValue });
    });
    trafficFiltersInternal = _.sortBy(trafficFiltersInternal, (f) => f.trafficFilter.displayOrder || 0);
    return trafficFiltersInternal;
  }
  removeHidden(trafficFilterDictionary) {
    const output = {
      trafficFilters: {}
    };
    _.forOwn(trafficFilterDictionary.trafficFilters, (filter, key) => {
      if (!filter.isHidden) {
        output.trafficFilters[key] = filter;
      }
    });
    return output;
  }
  getDifference(trafficFiltersLeft, trafficFiltersRight) {
    if (!trafficFiltersLeft) {
      trafficFiltersLeft = {
        trafficFilters: {}
      };
    } else {
      trafficFiltersLeft = _.cloneDeep(trafficFiltersLeft);
    }
    if (!trafficFiltersRight) {
      trafficFiltersRight = {
        trafficFilters: {}
      };
    } else {
      trafficFiltersRight = _.cloneDeep(trafficFiltersRight);
    }
    let difference = {
      trafficFilters: {}
    };
    _.forOwn(trafficFiltersLeft.trafficFilters, (filter, key) => {
      if (!trafficFiltersRight.trafficFilters[key]) {
        difference.trafficFilters[key] = filter;
      }
    });
    return difference;
  }
  // Combines the two TrafficFilterDiciontaries. For overlapping filters, left side takes precedence.
  getCombination(trafficFiltersLeft, trafficFiltersRight) {
    const combinedFilters = _.cloneDeep(trafficFiltersLeft);
    if (!!trafficFiltersRight) {
      _.forOwn(trafficFiltersRight.trafficFilters, (filter, key) => {
        if (!combinedFilters.trafficFilters[key]) {
          combinedFilters.trafficFilters[key] = filter;
        }
      });
    }
    return combinedFilters;
  }
  populateFiltersWithSelections(trafficFilters, selections) {
    let populatedFilters = {
      trafficFilters: {}
    };
    _.forOwn(trafficFilters.trafficFilters, (val, key) => {
      if (!!selections.trafficFilters[key]) {
        populatedFilters.trafficFilters[key] = selections.trafficFilters[key];
      } else {
        populatedFilters.trafficFilters[key] = val;
      }
    });
    return populatedFilters;
  }
  getSelectedTrafficFilters(trafficFilterDictionary, onlyEditable) {
    let trafficFilters = {};
    let keys = Object.keys(trafficFilterDictionary.trafficFilters);
    _.each(keys, (key) => {
      if (!onlyEditable || trafficFilterDictionary.trafficFilters[key].isEditable) {
        trafficFilters[key] = this.getSelectedTrafficFilterValues(trafficFilterDictionary.trafficFilters[key]);
      }
    });
    return trafficFilters;
  }
  getSelectedTrafficFilterValues(trafficFilter) {
    if (!this.hasValues(trafficFilter)) {
      return [];
    }
    if (trafficFilter.operatorCategory === OperatorCategory.InOnly) {
      return this.getSelectedInOnlyTrafficFilterValues(trafficFilter);
    } else {
      let trafficFilterBackend = [];
      _.forEach(trafficFilter.currentValue.clause, (ruleDictionary) => {
        let ruleSet = {};
        _.each(ruleDictionary.selectedBaseOperators, (operator) => {
          var _a;
          if ((_a = ruleDictionary == null ? void 0 : ruleDictionary.trafficFilterRule[operator]) == null ? void 0 : _a.includes("All Values")) {
            ruleDictionary.trafficFilterRule[operator] = [];
          }
          ruleSet[operator] = ruleDictionary.trafficFilterRule[operator];
        });
        trafficFilterBackend.push(ruleSet);
      });
      return trafficFilterBackend;
    }
  }
  getUpdatedTrafficFilterValues(trafficFilters) {
    let updatedSelectedFilters = {};
    _.forOwn(trafficFilters, (filter, key) => {
      var _a, _b, _c;
      if (!!((_a = filter == null ? void 0 : filter.currentValue) == null ? void 0 : _a.clause) && filter.currentValue.clause.length > 0 && !!filter.currentValue.clause[0].trafficFilterRule && !!filter.currentValue.clause[0].currentSelectedOperator && filter.currentValue.clause[0].currentSelectedOperator in filter.currentValue.clause[0].trafficFilterRule && ((_c = (_b = filter.currentValue.clause[0].trafficFilterRule[filter.currentValue.clause[0].currentSelectedOperator]) == null ? void 0 : _b.length) != null ? _c : 0) > 0 && filter.currentValue.clause[0].trafficFilterRule[filter.currentValue.clause[0].currentSelectedOperator][0] === "All Values") {
      } else {
        updatedSelectedFilters[key] = filter;
      }
    });
    return updatedSelectedFilters;
  }
  getSelectedInOnlyTrafficFilterValues(trafficFilter) {
    if (!trafficFilter || !trafficFilter.currentValue || !trafficFilter.currentValue.clause || !trafficFilter.currentValue.clause[0] || !trafficFilter.currentValue.clause[0].trafficFilterRule || !trafficFilter.currentValue.clause[0].trafficFilterRule[OperatorConstants.In] || trafficFilter.currentValue.clause[0].trafficFilterRule[OperatorConstants.In].includes("All Values")) {
      return [];
    }
    return trafficFilter.currentValue.clause[0].trafficFilterRule[OperatorConstants.In];
  }
  areTrafficFilterValuesValid(trafficFilters) {
    let validationInfo = progressionValidationInstance.validateTrafficFilters(
      trafficFilters,
      true
      // set inReadonlyMode to true to ignore required filters
    );
    if (_.isEmpty(validationInfo)) {
      return { hasInvalidValues: false, errors: "" };
    }
    return { hasInvalidValues: true, errors: _.map(validationInfo, (v) => v.message).join("\n") };
  }
  areSelectedValuesEqual(trafficFilter1, trafficFilter2) {
    if (!trafficFilter1 || !trafficFilter2) {
      return false;
    }
    if (!trafficFilter1.currentValue && !trafficFilter2.currentValue) {
      return true;
    }
    if (!trafficFilter1.currentValue || !trafficFilter2.currentValue) {
      return false;
    }
    if (EnvironmentService.enableProgressionStageAlertImprovements() && // second input needs to be the filters from the progression template
    this.areFilterClauseUndefined(trafficFilter2.currentValue, trafficFilter1.currentValue)) {
      return true;
    }
    let isSame = CommonUtilsInstance.IsArrayEqualIgnoreOrder(
      trafficFilter1.currentValue.clause,
      trafficFilter2.currentValue.clause,
      // @ts-ignore
      null,
      (c1, c2) => this.compareRuleSet(c1, c2)
    );
    return isSame;
  }
  // If the progression template has filters with no values (e.g. see below) then the backend will not create it.
  // This function checks if this is the case and returns true if so.
  //
  // from progression template
  // OSName: [
  //   {
  //       "trafficFilterRule": {
  //           "In": []
  //       },
  //       "currentSelectedOperator": "In",
  //       "selectedBaseOperators": [
  //           "In"
  //       ]
  //   }
  // ]
  //
  // from the progressions stage
  // OSName: []
  areFilterClauseUndefined(filterClause, templateClause) {
    filterClause = filterClause != null ? filterClause : { clause: [] };
    templateClause = templateClause != null ? templateClause : { clause: [] };
    if (_.isEmpty(filterClause.clause) && _.isEmpty(templateClause.clause)) {
      return false;
    }
    return _.isEmpty(filterClause.clause) && _.reduce(
      templateClause.clause,
      (acc, val) => acc && _.every(_.valuesIn(val.trafficFilterRule), (val2) => _.isNull(val2) || _.isEmpty(val2)),
      true
    );
  }
  compareRuleSet(rule1, rule2) {
    if (!CommonUtilsInstance.IsArrayEqualIgnoreOrder(rule1.selectedBaseOperators, rule2.selectedBaseOperators)) {
      return false;
    }
    let compare = true;
    rule1.selectedBaseOperators.forEach((o) => {
      if (!!rule1.trafficFilterRule && !!rule2.trafficFilterRule && !CommonUtilsInstance.IsArrayEqualIgnoreOrder(rule1.trafficFilterRule[o], rule2 == null ? void 0 : rule2.trafficFilterRule[o])) {
        compare = false;
      }
    });
    return compare;
  }
  setCurrentValueEmpty(trafficFilter) {
    if (!!trafficFilter.currentValue && !!trafficFilter.currentValue.clause) {
      _.forEach(trafficFilter.currentValue.clause, (r) => {
        _.forOwn(r.trafficFilterRule, (value, operator) => {
          r.trafficFilterRule[operator] = [];
        });
      });
    }
    return;
  }
  populateStageFiltersWithinProgression(trafficFilters, selections) {
    let populatedFilters = {
      trafficFilters: {}
    };
    _.forOwn(trafficFilters.trafficFilters, (val, key) => {
      if (!!selections.trafficFilters[key]) {
        populatedFilters.trafficFilters[key] = val;
      }
    });
    return populatedFilters;
  }
  isTrafficFilterValuesChanged(progressionTrafficFilters, targetTrafficFilters) {
    const keys = Object.keys(progressionTrafficFilters ? progressionTrafficFilters.trafficFilters : {});
    const targetTrafficFilterKeys = Object.keys(targetTrafficFilters ? targetTrafficFilters.trafficFilters : {});
    let changed = false;
    if (!!keys.length && !targetTrafficFilterKeys.length) {
      return true;
    }
    _.forEach(keys, (key) => {
      if (!targetTrafficFilters.trafficFilters[key]) {
        changed = true;
      }
      if (!this.areSelectedValuesEqual(progressionTrafficFilters.trafficFilters[key], targetTrafficFilters.trafficFilters[key])) {
        changed = true;
      }
    });
    return changed;
  }
  isRequiredTrafficFiltersPresent(trafficFilterDictionary) {
    let isRequiredTrafficFiltersPresent = true;
    _.forOwn(trafficFilterDictionary.trafficFilters, (trafficFilter, trafficFilterId) => {
      if (trafficFilter.isRequired) {
        if (!this.hasValues(trafficFilter)) {
          isRequiredTrafficFiltersPresent = false;
        }
      }
    });
    return isRequiredTrafficFiltersPresent;
  }
  getTrafficFilterValuesChanged(progressionTrafficFilters, targetTrafficFilters) {
    const keys = Object.keys(progressionTrafficFilters ? progressionTrafficFilters.trafficFilters : {});
    const targetTrafficFilterKeys = Object.keys(targetTrafficFilters ? targetTrafficFilters.trafficFilters : {});
    let changedTrafficFilters = { trafficFilters: {} };
    _.forEach(keys, (key) => {
      if (!targetTrafficFilterKeys.length || !targetTrafficFilters.trafficFilters[key] || !this.areSelectedValuesEqual(progressionTrafficFilters.trafficFilters[key], targetTrafficFilters.trafficFilters[key])) {
        changedTrafficFilters.trafficFilters[key] = progressionTrafficFilters == null ? void 0 : progressionTrafficFilters.trafficFilters[key];
      }
    });
    return changedTrafficFilters;
  }
  /** Restricts the selectable traffic filters to values specified in MDS */
  getRestrictedFilters(allTrafficFilters, mdsFilters, type) {
    let result = {};
    let filteredKeys = Object.keys(allTrafficFilters.trafficFilters).filter(
      (key) => !!mdsFilters[key] && !!mdsFilters[key].EnabledOverrideTypes && containsIgnoreCase(mdsFilters[key].EnabledOverrideTypes, type)
    );
    _.each(filteredKeys, (key) => {
      result[key] = allTrafficFilters.trafficFilters[key];
    });
    return {
      trafficFilters: result
    };
  }
  convertTrafficFilter(originalTrafficFilters, mdsFilters) {
    let trafficFiltersConverted = { trafficFilters: {} };
    _.forOwn(originalTrafficFilters, (templateTrafficFilterData, trafficFilterKey) => {
      trafficFiltersConverted.trafficFilters[trafficFilterKey] = MasterDataUtilInstance.toTrafficFilter(
        trafficFilterKey,
        mdsFilters,
        templateTrafficFilterData.IsRequired || false,
        templateTrafficFilterData.IsEditable || false,
        templateTrafficFilterData.AllowNoFilter || false,
        templateTrafficFilterData.Values,
        true
      );
    });
    return trafficFiltersConverted;
  }
  ////////////////////////// Display Utils ////////////////////////////
  trafficFilterClauseToString(trafficFilterClause, valueOption) {
    if (!trafficFilterClause || !trafficFilterClause.clause) {
      return "";
    }
    let clauses = trafficFilterClause.clause.map((c) => `${this.trafficFilterRuleToString(c, valueOption)}`);
    return clauses.join(" OR ");
  }
  trafficFilterRuleToString(trafficFilterRuleDict, valueOption) {
    let operators = Object.keys(trafficFilterRuleDict.trafficFilterRule).filter(
      (o) => trafficFilterRuleDict.selectedBaseOperators.indexOf(o) >= 0
    );
    let operatorValueStrings = operators.map(
      (o) => `${this.operatorNameToDisplayName(o)} ${this.valuesToString(trafficFilterRuleDict.trafficFilterRule[o], valueOption)}`
    );
    let startSymbol = operatorValueStrings.length > 1 ? "(" : "";
    let endSymbol = operatorValueStrings.length > 1 ? ")" : "";
    return `${startSymbol}${operatorValueStrings.join(" and ")}${endSymbol}`;
  }
  valuesToString(trafficFilterValues, valueOption) {
    if (!trafficFilterValues) {
      return "";
    }
    let valueToDisplayValue = {};
    if (valueOption && valueOption.predefinedValues) {
      _.each(valueOption.predefinedValues, (preDefVal) => {
        valueToDisplayValue[preDefVal.name] = preDefVal.displayName;
      });
    }
    return `[${trafficFilterValues.map((tfv) => valueToDisplayValue[tfv] || tfv).join(",")}]`;
  }
  operatorNameToDisplayName(operatorName) {
    switch (operatorName) {
      case OperatorConstants.In:
        return "";
      case OperatorConstants.NotIn:
        return "except";
      case OperatorConstants.GreaterThan:
        return ">";
      case OperatorConstants.GreaterThanOrEqual:
        return ">=";
      case OperatorConstants.LessThan:
        return "<";
      case OperatorConstants.LessThanOrEqual:
        return "<=";
      default:
        return operatorName;
    }
  }
  getTrafficFiltersDifferences(initialTrafficFilters, trafficFilters) {
    const initialFormatted = this.getSelectedTrafficFilters(initialTrafficFilters);
    const trafficFormatted = this.getSelectedTrafficFilters(trafficFilters);
    let arr = [];
    const initalKeys = Object.keys(initialFormatted);
    const trafficFilterKeys = Object.keys(trafficFormatted);
    _.forEach(initalKeys, (key) => {
      const changedInitialVal = this.trafficFilterClauseToString(
        initialTrafficFilters.trafficFilters[key].currentValue,
        // @ts-ignore
        initialTrafficFilters.trafficFilters[key].valueOption
      );
      if (!trafficFormatted[key] || trafficFormatted[key].length == 0) {
        arr.push(`${key} : ${changedInitialVal} -> []`);
      } else if (!_.isEqual(initialFormatted[key], trafficFormatted[key])) {
        const changedFinalVal = this.trafficFilterClauseToString(
          trafficFilters.trafficFilters[key].currentValue,
          // @ts-ignore
          trafficFilters.trafficFilters[key].valueOption
        );
        arr.push(`${key} : ${changedInitialVal} -> ${changedFinalVal}`);
      }
    });
    _.forEach(trafficFilterKeys, (key) => {
      if (!initialFormatted[key] && trafficFormatted[key].length) {
        const changedFinalVal = this.trafficFilterClauseToString(
          trafficFilters.trafficFilters[key].currentValue,
          // @ts-ignore
          trafficFilters.trafficFilters[key].valueOption
        );
        arr.push(`${key} : [] -> ${changedFinalVal}`);
      }
    });
    return arr;
  }
  /** Value Edit Utils */
  getCurrentOperator(index, trafficFilterClause) {
    if (!trafficFilterClause || !trafficFilterClause.clause || !trafficFilterClause.clause[index] || !trafficFilterClause.clause[index].currentSelectedOperator) {
      return OperatorConstants.In;
    }
    return trafficFilterClause.clause[index].currentSelectedOperator;
  }
  getCurrentValue(index, trafficFilterClause) {
    if (!trafficFilterClause || !trafficFilterClause.clause || !trafficFilterClause.clause[index] || !trafficFilterClause.clause[index].trafficFilterRule) {
      return [];
    }
    const currentSelectedOperator = this.getCurrentOperator(index, trafficFilterClause);
    if (!trafficFilterClause.clause[index].trafficFilterRule[currentSelectedOperator]) {
      return [];
    }
    return trafficFilterClause.clause[index].trafficFilterRule[currentSelectedOperator];
  }
  getCurrentBaseOperators(index, trafficFilterClause) {
    if (!trafficFilterClause || !trafficFilterClause.clause || !trafficFilterClause.clause[index]) {
      return [OperatorConstants.In];
    }
    return trafficFilterClause.clause[index].selectedBaseOperators;
  }
  getInValues(trafficFilterDictionary) {
    let result = {};
    _.forOwn(trafficFilterDictionary.trafficFilters, (tf) => {
      result[tf.displayName] = this.getSelectedInOnlyTrafficFilterValues(tf);
    });
    return result;
  }
  getAllowedOperators(operatorCategory) {
    switch (operatorCategory) {
      case OperatorCategory.InOnly:
        return [{ operator: OperatorConstants.In, displayOperator: "In" }];
      case OperatorCategory.InAndNotIn:
        return [
          { operator: OperatorConstants.In, displayOperator: "In" },
          { operator: OperatorConstants.NotIn, displayOperator: "Not in" }
        ];
      case OperatorCategory.AllOperators:
        return [
          { operator: OperatorConstants.In, displayOperator: "In" },
          { operator: OperatorConstants.NotIn, displayOperator: "Not in" },
          { operator: OperatorConstants.GreaterThanOrEqual, displayOperator: ">=" },
          { operator: OperatorConstants.GreaterThan, displayOperator: ">" },
          { operator: OperatorConstants.LessThanOrEqual, displayOperator: "<=" },
          { operator: OperatorConstants.LessThan, displayOperator: "<" },
          { operator: CustomOperatorConstants.Between, displayOperator: "Between" }
        ];
      default:
        return [];
    }
  }
  populateFilterWithSelectedValues(trafficFilter, rulePosition, newValues) {
    let result = _.cloneDeep(trafficFilter);
    let currentOperator = this.getCurrentOperator(rulePosition, trafficFilter.currentValue);
    let baseOperators = this.getCurrentBaseOperators(rulePosition, trafficFilter.currentValue);
    result.currentValue.clause[rulePosition] = {
      trafficFilterRule: {
        [currentOperator]: newValues
      },
      currentSelectedOperator: currentOperator,
      selectedBaseOperators: baseOperators
    };
    return result;
  }
}
const TrafficFilterUtilInstance = new TrafficFilterUtils();
export {
  findProgressionInProgressionCloneGroups as A,
  getProgressionInProgressionCloneGroups as B,
  getProgressionTargetSequence as C,
  parseAssignmentUnitSelection as D,
  EDITABLE_FLIGHTS as E,
  FeatureUtilsV2 as F,
  GuidLength as G,
  isFeatureDeleteAllowed as H,
  IterateProgressionDisableReasons as I,
  ProgressionSelectionUtils as J,
  ProgressionSelectionUtilInstance as K,
  MasterDataUtilInstance as L,
  MasterDataUtils as M,
  ProgressionDialogType as N,
  ProgressionValidation as O,
  ProgressionStageEditAvailability as P,
  progressionValidationInstance as Q,
  RelativePosition as R,
  TrafficFilterUtils as S,
  TrafficFilterUtilInstance as T,
  generateNewFlightName as a,
  getExpandedFlightList as b,
  createControlFlight as c,
  getEditableFlights as d,
  generateRandomFlightName as e,
  getFormattedTreatmentVariables as f,
  getRandomIntInclusive as g,
  hasTreatmentVariables as h,
  validateFlightNameCharacters as i,
  featureUtilsV2Instance as j,
  ProgressionUtils as k,
  ProgressionUtilsInstance as l,
  getControlFlightSuffix as m,
  createFeatureRequest as n,
  createFeatureRequestFormik as o,
  getExtensionsProperties as p,
  parseFlightList as q,
  parseFeatureInfo as r,
  parseTrafficFilters as s,
  nestRestartedFromStagesIntoProgressionStage as t,
  groupRestartedProgressionStages as u,
  validateFlightName as v,
  populateParents as w,
  constructProgressionCloneGroups as x,
  getOriginalProgression as y,
  areProgressionGroupsEqual as z
};
//# sourceMappingURL=TrafficFilterUtils-00255d1a.js.map
